const bhamPoly2 = {
  type: "FeatureCollection",
  name: "const_wgs84",
  crs: { type: "name", properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" } },
  features: [
    {
      type: "Feature",
      properties: {
        objectid: 281,
        lad16cd: "E08000025",
        lad16nm: "Birmingham",
        lad16nmw: null,
        bng_e: 408150,
        bng_n: 287352,
        long: -1.88141,
        lat: 52.48403931,
        st_areasha: 267761492.89704117,
        st_lengths: 104149.1206092413
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-1.827868453076975, 52.608673092027317],
            [-1.811824499338781, 52.604392927565193],
            [-1.803942850974642, 52.601336194694234],
            [-1.801816343307613, 52.601096296697186],
            [-1.7975788991756, 52.599153563620185],
            [-1.796535277078111, 52.599106841525177],
            [-1.794278770479531, 52.596086928259709],
            [-1.795321245430813, 52.595082701849897],
            [-1.792764666778076, 52.593763071698866],
            [-1.789729913603162, 52.591527369121607],
            [-1.788120586667602, 52.587907053522223],
            [-1.78808850524636, 52.587846691660381],
            [-1.788467913353238, 52.58689535091704],
            [-1.788284261886966, 52.5845711927062],
            [-1.784843031737333, 52.581726018258415],
            [-1.783856476188437, 52.581568655219804],
            [-1.783614995448742, 52.581161002040986],
            [-1.781365976939132, 52.580254287684689],
            [-1.780275120004909, 52.578843609160892],
            [-1.77950256831621, 52.578682112084664],
            [-1.778691312807483, 52.576564462144795],
            [-1.779158442627623, 52.576385497932272],
            [-1.778839702052877, 52.575798755326595],
            [-1.777954707084745, 52.575726102263793],
            [-1.778006293087598, 52.575147239464393],
            [-1.776656283684172, 52.574553162440054],
            [-1.774178601506982, 52.574582620623687],
            [-1.773380347014488, 52.574871476250038],
            [-1.771939634775639, 52.574679082175379],
            [-1.770936887740723, 52.575123905916456],
            [-1.769695277012668, 52.574966919504831],
            [-1.769018495106495, 52.574288593025962],
            [-1.768140632831991, 52.574279689395482],
            [-1.767730806388496, 52.573370904122861],
            [-1.768206522103053, 52.57297271079203],
            [-1.767023599736609, 52.571211135973975],
            [-1.765914267648261, 52.570909584651368],
            [-1.763553196153099, 52.570963315947729],
            [-1.763570358434312, 52.570236910043029],
            [-1.765118327681678, 52.569080359745413],
            [-1.766799378416498, 52.56871151523243],
            [-1.767909310262046, 52.568059240995879],
            [-1.769157038180105, 52.568147954470867],
            [-1.771259910016981, 52.567492185109678],
            [-1.773914768714163, 52.565620196656653],
            [-1.77423716892854, 52.564612169244761],
            [-1.770412229947926, 52.563681560590666],
            [-1.76692107903857, 52.561602551288203],
            [-1.766926038464921, 52.559838717590921],
            [-1.767738406218733, 52.558790327510273],
            [-1.76630064711759, 52.55787052903915],
            [-1.765346932415609, 52.55666129245283],
            [-1.763431231327562, 52.556603560748137],
            [-1.759959874109806, 52.555652647188786],
            [-1.757820312999453, 52.555555726368617],
            [-1.756407082195768, 52.555863879693646],
            [-1.756005604138514, 52.555366775714738],
            [-1.75358421875439, 52.545286824350875],
            [-1.75211340484488, 52.543825566996631],
            [-1.746435345375718, 52.541697402134105],
            [-1.749000523539685, 52.541246127223339],
            [-1.748368568330059, 52.536505325058343],
            [-1.750921911760178, 52.536262579369641],
            [-1.750418965755576, 52.533956542530099],
            [-1.749093392294729, 52.531406914626054],
            [-1.746860775827682, 52.531299711042401],
            [-1.743534515301817, 52.532677864656698],
            [-1.74235438853196, 52.531289998491914],
            [-1.739429039409574, 52.531895818582178],
            [-1.738677759967122, 52.529069535147002],
            [-1.739762511824746, 52.529104277191585],
            [-1.738830469139873, 52.528690426734684],
            [-1.736923776849176, 52.529063856787808],
            [-1.731578262160014, 52.527701520429105],
            [-1.730828919897807, 52.525865864066709],
            [-1.730426056980665, 52.525945024909063],
            [-1.728858051515413, 52.524451794753872],
            [-1.729643309306203, 52.524258473865679],
            [-1.730515380255669, 52.523142166206675],
            [-1.731844781095601, 52.522907826184614],
            [-1.733792762531704, 52.523467816526882],
            [-1.734833553631731, 52.523413530126255],
            [-1.736332216768464, 52.522488212693112],
            [-1.73813699531702, 52.522101984518081],
            [-1.738767692074162, 52.521606286448481],
            [-1.741643979255882, 52.520714487768373],
            [-1.743875726797577, 52.520625864958852],
            [-1.745830281247272, 52.520054703861483],
            [-1.746911927688062, 52.520084880808099],
            [-1.748769442591289, 52.520752279149754],
            [-1.75134806602591, 52.520583274660559],
            [-1.75381754878502, 52.521197952989105],
            [-1.754326516542037, 52.518460745009598],
            [-1.757046466044242, 52.518282921264131],
            [-1.757084420348359, 52.517811972199858],
            [-1.754929739201851, 52.515717347568163],
            [-1.75409843341303, 52.515761460314025],
            [-1.75326476266747, 52.514100212023642],
            [-1.753941261359895, 52.513814833021165],
            [-1.75353057342051, 52.512951821913958],
            [-1.760501819354678, 52.514311885487672],
            [-1.764408725455953, 52.514477984904971],
            [-1.768491824686077, 52.514228904982609],
            [-1.773610202988577, 52.513232840193822],
            [-1.782524330211374, 52.51038445815459],
            [-1.787169949685341, 52.509496583922143],
            [-1.791659489665242, 52.509155763069764],
            [-1.793927154481494, 52.508824410232059],
            [-1.794832730958293, 52.508289256741961],
            [-1.794032283090398, 52.507747548208606],
            [-1.794314747922936, 52.506568627288139],
            [-1.7983729935024, 52.505765571246172],
            [-1.799365704734478, 52.504848478697689],
            [-1.799301758511232, 52.503685045868686],
            [-1.798250683408366, 52.502867028721262],
            [-1.796946489850525, 52.502636432365954],
            [-1.794534119381032, 52.50281480744745],
            [-1.791503177471508, 52.502953310703163],
            [-1.782548395142229, 52.501608522663012],
            [-1.781986489224737, 52.501442032895447],
            [-1.78217195419139, 52.501172663167779],
            [-1.779402654159249, 52.501152261085075],
            [-1.772463333469079, 52.50161744474449],
            [-1.772030477299839, 52.501846779462099],
            [-1.771544173561617, 52.501606688680255],
            [-1.771406016975086, 52.501828499859307],
            [-1.770363893444069, 52.50166192635151],
            [-1.770278904255116, 52.501282404852354],
            [-1.764181357055089, 52.500784926419229],
            [-1.764190621706263, 52.499869761134946],
            [-1.761549913118859, 52.499781791350784],
            [-1.761499639169453, 52.500094540318351],
            [-1.758898561592632, 52.499753956540722],
            [-1.758739055548076, 52.500093444648329],
            [-1.755844853877702, 52.499480687378231],
            [-1.756966287610437, 52.496739326821455],
            [-1.758970578208474, 52.495197142502079],
            [-1.759907035366991, 52.494704557958798],
            [-1.760344131200295, 52.493693194628115],
            [-1.760846802318064, 52.49361961452999],
            [-1.761015551975588, 52.491565709080234],
            [-1.761602255355819, 52.490363120194694],
            [-1.762366652575942, 52.49009314663261],
            [-1.762332144707923, 52.488563872941299],
            [-1.761120265998172, 52.488260267844986],
            [-1.763662442627803, 52.48709583820127],
            [-1.763101034846583, 52.486612812291867],
            [-1.762071941940845, 52.48655682521094],
            [-1.761485914396342, 52.486814573914074],
            [-1.760868145911991, 52.48640790691902],
            [-1.761568293111184, 52.485208242259247],
            [-1.761102101564132, 52.485087680614164],
            [-1.760419101828237, 52.483953619637489],
            [-1.759481473462808, 52.483879820358915],
            [-1.759053467432709, 52.483239766133394],
            [-1.759813665397305, 52.482918482818462],
            [-1.758879173674495, 52.480385012442753],
            [-1.759862897460196, 52.480362745173103],
            [-1.759664574232776, 52.479461535423098],
            [-1.759103336530675, 52.479507219601189],
            [-1.758718934120181, 52.477649998120533],
            [-1.758607018179623, 52.47656013653279],
            [-1.759163745733584, 52.476533409017371],
            [-1.759169957062795, 52.475394446368405],
            [-1.755810492385743, 52.471887688815066],
            [-1.75669868142848, 52.471524537489813],
            [-1.759330287880282, 52.468939020807134],
            [-1.758736188604863, 52.467203598570165],
            [-1.759956319611992, 52.46697330346673],
            [-1.761723097991975, 52.467164708280997],
            [-1.763754245825923, 52.466104396658558],
            [-1.763385093782597, 52.463831908177418],
            [-1.754984355299141, 52.456269512746076],
            [-1.759607023761831, 52.451896349917583],
            [-1.761398731421792, 52.450908387796794],
            [-1.762773053835223, 52.45118077326233],
            [-1.766681764749831, 52.451074398254626],
            [-1.766667474964298, 52.450724668155843],
            [-1.769021264000956, 52.451087971949704],
            [-1.772484193782199, 52.450702733346979],
            [-1.773342025700011, 52.450992066188348],
            [-1.77438984967803, 52.45066503682591],
            [-1.777484497356956, 52.450616967234446],
            [-1.777957569062974, 52.450173696030781],
            [-1.779112820814826, 52.450139456772675],
            [-1.779136440386376, 52.450414157634704],
            [-1.781460099950297, 52.450655826557657],
            [-1.781645183385318, 52.451034629782939],
            [-1.78246154431638, 52.45108646188573],
            [-1.782709984183144, 52.450845065799896],
            [-1.788986656536718, 52.453081436594424],
            [-1.789426796894489, 52.452757683133655],
            [-1.79028956531279, 52.452958825557523],
            [-1.790508645017531, 52.452685006137294],
            [-1.791313841048837, 52.452951647467216],
            [-1.790912221298883, 52.453239525774244],
            [-1.793994528377389, 52.454285941860327],
            [-1.79483115178809, 52.455085748423613],
            [-1.795298291977692, 52.45524114083274],
            [-1.795689200893302, 52.455036812089602],
            [-1.798749483696197, 52.457454998475654],
            [-1.800323276036327, 52.458282977791491],
            [-1.804918809259767, 52.454414085932953],
            [-1.805394457009461, 52.454682783241637],
            [-1.805971002526636, 52.45407959409598],
            [-1.805129665858275, 52.453316796718845],
            [-1.80626016763705, 52.451552079491826],
            [-1.806072396355851, 52.449745746344426],
            [-1.806684792740813, 52.449666668855031],
            [-1.808281767078459, 52.446517367294931],
            [-1.809269401785423, 52.445379083591149],
            [-1.810016131662038, 52.445216622138041],
            [-1.809579569470849, 52.44476196441822],
            [-1.812276497319232, 52.442997898320428],
            [-1.811577625788279, 52.442329740241085],
            [-1.812421931805164, 52.441997555758839],
            [-1.811843487185802, 52.441394299123502],
            [-1.812804555965244, 52.440580389444634],
            [-1.811910592776223, 52.440474718455505],
            [-1.813404820964133, 52.438484922346028],
            [-1.81448768601807, 52.437729609514285],
            [-1.816115741989157, 52.43780593498127],
            [-1.8173210338712, 52.432352588316974],
            [-1.819246371458267, 52.430885641539945],
            [-1.825269656688436, 52.429290866710865],
            [-1.827036064051032, 52.427774217035719],
            [-1.828005052959522, 52.425554103243933],
            [-1.830731814402956, 52.422781079680824],
            [-1.832898466854786, 52.419499140768345],
            [-1.834416607544507, 52.418549228237971],
            [-1.833735854648356, 52.418138355588539],
            [-1.834650202023819, 52.417418658701287],
            [-1.839066393313986, 52.41433574103096],
            [-1.842371837522379, 52.412600566714431],
            [-1.843615625158655, 52.410509296384333],
            [-1.847824994519294, 52.409951173776456],
            [-1.84872588202177, 52.410003555921747],
            [-1.849440695793769, 52.410774875428395],
            [-1.850259699590532, 52.41027881479954],
            [-1.850842810760379, 52.41043143959002],
            [-1.853949464221311, 52.408544700261977],
            [-1.857817562701825, 52.408404707518116],
            [-1.862765805125379, 52.409322145704429],
            [-1.864137992000348, 52.41007256524172],
            [-1.864770353717485, 52.410981295759939],
            [-1.866651892271066, 52.411031062367158],
            [-1.865643817245784, 52.409937673028836],
            [-1.866258612923861, 52.40980885858928],
            [-1.867120240725546, 52.408772400769401],
            [-1.868793314957193, 52.407724256330795],
            [-1.86920325257077, 52.407795710521981],
            [-1.868753721207189, 52.404723284418374],
            [-1.872284613100749, 52.404676813273518],
            [-1.872297627086753, 52.402179379299099],
            [-1.877869011848504, 52.402430701446349],
            [-1.87836111821276, 52.399883428758862],
            [-1.882704353282328, 52.399798741260206],
            [-1.886199545036121, 52.404343088175274],
            [-1.885945885075261, 52.404673674688617],
            [-1.886695435365025, 52.404687874318185],
            [-1.887121839055415, 52.404671205473349],
            [-1.89238761464778, 52.404418971346395],
            [-1.89613981422939, 52.403312900697195],
            [-1.9006967735565, 52.403821184200623],
            [-1.904594820461718, 52.403131269069902],
            [-1.906633058528605, 52.404079545965722],
            [-1.909673546760337, 52.404432503322035],
            [-1.910818436144979, 52.40667638088631],
            [-1.913681851206681, 52.407449896338541],
            [-1.913965688124249, 52.406646350583742],
            [-1.914656466706168, 52.406740319454919],
            [-1.915310044099477, 52.40314929247743],
            [-1.916475792593835, 52.401529222286513],
            [-1.918303807220029, 52.400119006874355],
            [-1.918585116510375, 52.39817825737768],
            [-1.922444013950404, 52.396841344605107],
            [-1.923143182283032, 52.396210696383932],
            [-1.924390083337454, 52.396678938136603],
            [-1.928280002595595, 52.393124902470063],
            [-1.928080607602318, 52.392876636342415],
            [-1.932079813641562, 52.390490289501024],
            [-1.932866261913814, 52.390310986284817],
            [-1.93464343159216, 52.387875639935757],
            [-1.934162007158482, 52.387535555259284],
            [-1.934322627951342, 52.387221889720216],
            [-1.936353660127182, 52.387890050822236],
            [-1.939679423622854, 52.389585575734884],
            [-1.945028335865184, 52.390556398286613],
            [-1.952905912165111, 52.39337907638938],
            [-1.953621646666809, 52.393355990697266],
            [-1.958919630056098, 52.388233523327862],
            [-1.959416226120784, 52.388227402474151],
            [-1.959550773142919, 52.388949416110528],
            [-1.960442574473656, 52.389078237433452],
            [-1.964934982533633, 52.392173150470626],
            [-1.966369751760017, 52.389450434771817],
            [-1.968835453433114, 52.389443015704174],
            [-1.968967802017783, 52.389197601699109],
            [-1.969724192314773, 52.389674314424596],
            [-1.970554475929715, 52.389642166936518],
            [-1.97162889895552, 52.389200960481624],
            [-1.97246563963254, 52.388111598854067],
            [-1.975585655975473, 52.387096416859535],
            [-1.977805485408315, 52.387689306973584],
            [-1.978600425361968, 52.387499725614326],
            [-1.978935349704411, 52.38785757838555],
            [-1.98335525497276, 52.387380046931241],
            [-1.985508242735015, 52.385976923289753],
            [-1.988198854103562, 52.384488432085782],
            [-1.988153702215125, 52.383436616867897],
            [-1.989285098785948, 52.382472090185082],
            [-1.992889142214548, 52.381937415507672],
            [-1.994710937960205, 52.381128449363509],
            [-1.997330372114577, 52.381052946449095],
            [-2.0001260484284, 52.381649023484663],
            [-2.001288247344741, 52.383551316059162],
            [-2.002194708957849, 52.383515350146823],
            [-2.002216793335258, 52.384185999829917],
            [-2.004175329288379, 52.383943278898549],
            [-2.005009747868928, 52.384140970282019],
            [-2.006145757270975, 52.385656660855766],
            [-2.008468911970327, 52.386948379718824],
            [-2.01136178646765, 52.386166934895101],
            [-2.012959695957056, 52.388686689156302],
            [-2.013375069916817, 52.392059659101314],
            [-2.014192753221844, 52.394210904158221],
            [-2.015083474132145, 52.394654955310862],
            [-2.016911480489598, 52.394247389910198],
            [-2.018082952017716, 52.39493502851257],
            [-2.019279837331525, 52.396288715057658],
            [-2.020694988641251, 52.399342429267755],
            [-2.021365643687525, 52.4001801237685],
            [-2.025110799322206, 52.400653200534833],
            [-2.025791217974364, 52.400404009353963],
            [-2.028417616221478, 52.400418680012727],
            [-2.03096216659523, 52.400876577938462],
            [-2.03221629682609, 52.401534304825709],
            [-2.033648580966104, 52.402314198261159],
            [-2.033443341510639, 52.403019056480957],
            [-2.028065787066833, 52.406417833101266],
            [-2.02732241454785, 52.407099440917669],
            [-2.027278580816108, 52.407554398088912],
            [-2.027868308009218, 52.407870708763539],
            [-2.027542047600706, 52.408090979684694],
            [-2.024185082542548, 52.406356684851907],
            [-2.023167818891793, 52.406277801581986],
            [-2.022036210191418, 52.406802980309386],
            [-2.02048547860665, 52.406853681632136],
            [-2.017556763628451, 52.405568498288069],
            [-2.015078601219188, 52.406109174302671],
            [-2.014282214578895, 52.406866291932573],
            [-2.012685893532811, 52.407302460857345],
            [-2.01235684175437, 52.408190730485607],
            [-2.012807136799025, 52.409496024874151],
            [-2.010866618181757, 52.409543857337908],
            [-2.009245280749318, 52.410373814218637],
            [-2.008104241295909, 52.408605521284478],
            [-2.006449022742354, 52.409119891027849],
            [-2.004646692769332, 52.409208956104685],
            [-2.004208829289734, 52.41095488362555],
            [-2.002797543590031, 52.410663644233907],
            [-2.002084593612184, 52.410856891178298],
            [-2.001020221736612, 52.410294111539656],
            [-1.99862392070272, 52.409743089732352],
            [-1.998149140328251, 52.409973164354781],
            [-1.997799221696215, 52.409718813116022],
            [-1.996933272333459, 52.410339112037732],
            [-1.995615886092208, 52.412481331717721],
            [-1.993251780855543, 52.41355828618088],
            [-1.991081729858211, 52.413544666674099],
            [-1.988868989643081, 52.41410727970171],
            [-1.986043876236232, 52.416711379679924],
            [-1.988225775737306, 52.416974136172726],
            [-1.98870369004716, 52.416353866148874],
            [-1.99104899927133, 52.41539842235062],
            [-1.997068115867698, 52.417411547835975],
            [-1.997016683056084, 52.417927608082699],
            [-1.999025096836625, 52.418698942337976],
            [-2.000374923342349, 52.420229061022702],
            [-2.002049728749285, 52.420973382882536],
            [-2.001282195876741, 52.421857134157641],
            [-2.00282623704187, 52.42231654380663],
            [-2.001655790370135, 52.422984517301543],
            [-2.003398513283023, 52.425377659839796],
            [-2.003522142183053, 52.426246024659022],
            [-2.004323637661207, 52.42635663220868],
            [-2.004692963052801, 52.428395513952289],
            [-2.00656513253703, 52.427913602312366],
            [-2.007303378763803, 52.428078927316022],
            [-2.009747348946936, 52.426507286939071],
            [-2.013184843792163, 52.428705909275749],
            [-2.012577767121075, 52.429790224488137],
            [-2.013789591000761, 52.429537448726975],
            [-2.015465829965176, 52.428596879899132],
            [-2.015286285148026, 52.432159622589658],
            [-2.015811439954608, 52.432649548603109],
            [-2.016996991776906, 52.432668255179379],
            [-2.017007512645688, 52.440659446633212],
            [-2.017440957738935, 52.443241295403631],
            [-2.016518457273633, 52.446716962053628],
            [-2.015274025514464, 52.447644006410606],
            [-2.013239349968182, 52.448341051851969],
            [-2.013517929243688, 52.449643658008213],
            [-2.013044278192247, 52.450358393276382],
            [-2.012126642614227, 52.452178087314152],
            [-2.011510917025078, 52.455349812519771],
            [-2.011763067455, 52.457207128037254],
            [-2.01308997936355, 52.460268998893973],
            [-2.013249515302932, 52.462132611302387],
            [-2.013249528511593, 52.46217575064383],
            [-2.007911199330795, 52.461899337679206],
            [-2.004398030452347, 52.462577358786319],
            [-2.002093212063011, 52.463382969276545],
            [-1.997729164908442, 52.463097985174429],
            [-1.98796291629486, 52.465351188675498],
            [-1.98172010369364, 52.466276375080859],
            [-1.977247769556674, 52.467416381048949],
            [-1.968322575262985, 52.472224943862763],
            [-1.965741098320539, 52.473294000647222],
            [-1.965812925579155, 52.473649112422692],
            [-1.967135976944924, 52.474182617326619],
            [-1.96538023732159, 52.475307611247516],
            [-1.969030448791457, 52.476778502816138],
            [-1.968411399316824, 52.477731273850019],
            [-1.968698416899436, 52.477847376632603],
            [-1.967038258215888, 52.478938267545303],
            [-1.964695180971553, 52.481498822337308],
            [-1.96180662966317, 52.482719676400649],
            [-1.958790888054588, 52.482798658440402],
            [-1.956129135333498, 52.482293425775367],
            [-1.952492341734182, 52.483345620712434],
            [-1.951572634640147, 52.482811219678972],
            [-1.950782889663331, 52.483231684752084],
            [-1.949524647291041, 52.485212515091575],
            [-1.950726000166123, 52.485479134818263],
            [-1.94971091271255, 52.487127444191664],
            [-1.948434339870023, 52.486984896875363],
            [-1.948031585741554, 52.487608625730239],
            [-1.947096550827922, 52.487476009088375],
            [-1.94595199012083, 52.490196780486144],
            [-1.943943414903816, 52.48992074741524],
            [-1.943145243412755, 52.491072908723893],
            [-1.943423384531396, 52.491214143050676],
            [-1.942885299862727, 52.491605824728722],
            [-1.945689116723307, 52.493151617454735],
            [-1.945533941469834, 52.493529195812336],
            [-1.94383026798269, 52.494402154987192],
            [-1.944316074351126, 52.495720380023904],
            [-1.941419420437161, 52.497527694285097],
            [-1.938137840063218, 52.49840975897294],
            [-1.942590924237267, 52.499398175894683],
            [-1.942468502018255, 52.499582447120765],
            [-1.943007886715565, 52.499391186363972],
            [-1.94571903066592, 52.499957040460231],
            [-1.950824572523079, 52.501475877661008],
            [-1.952843967232652, 52.501707759528799],
            [-1.955529594564394, 52.501581083240538],
            [-1.955490291116352, 52.502620275979361],
            [-1.957300223760081, 52.503243043332262],
            [-1.963030919351894, 52.504882094338321],
            [-1.961155502217443, 52.506602126047994],
            [-1.961975362709763, 52.50755891314305],
            [-1.961267518596681, 52.508250890703472],
            [-1.962241356560118, 52.508320494805901],
            [-1.961982136406531, 52.509860393625715],
            [-1.959574769504069, 52.509651903634541],
            [-1.962271580499801, 52.512635596366557],
            [-1.962649416361299, 52.513646251103879],
            [-1.962113994958599, 52.515921404628038],
            [-1.960206159105812, 52.517050759622578],
            [-1.959907882082645, 52.5177079032132],
            [-1.958800571774893, 52.518399729756553],
            [-1.958044532384093, 52.519963709999189],
            [-1.959498490665666, 52.522274583989756],
            [-1.960113697315521, 52.524881833159313],
            [-1.962084639912283, 52.527946251685492],
            [-1.960484703401648, 52.530208467611914],
            [-1.960243408390396, 52.531335755255931],
            [-1.958089744215165, 52.531389840132299],
            [-1.957570898768652, 52.529719364410084],
            [-1.951247080124741, 52.529779854098194],
            [-1.949801686079166, 52.530475950175607],
            [-1.947980247716075, 52.532574332650924],
            [-1.947273745333312, 52.532842832490509],
            [-1.947473613597222, 52.533418287445876],
            [-1.945792417546664, 52.533865191379149],
            [-1.941516130923988, 52.533627608218112],
            [-1.937252084805932, 52.531991092363093],
            [-1.933783808299215, 52.532725451380152],
            [-1.932634247585191, 52.532469565583874],
            [-1.932486668117852, 52.532643836044699],
            [-1.929446050601334, 52.531283727499954],
            [-1.930352430101089, 52.533341996210751],
            [-1.929445396586592, 52.542806883430849],
            [-1.929947014511153, 52.543572267873458],
            [-1.933155210198725, 52.545797300918792],
            [-1.921195680121317, 52.546035413949078],
            [-1.919814814680874, 52.546327565522681],
            [-1.918511499184301, 52.547017081660783],
            [-1.918163011762365, 52.547291044402726],
            [-1.916805284382138, 52.548628667367488],
            [-1.911840720902396, 52.551928899930232],
            [-1.90816282683793, 52.553211651959906],
            [-1.901285824850331, 52.554399014320808],
            [-1.89979919692057, 52.554983919469642],
            [-1.89810229654926, 52.556607822930346],
            [-1.896688422921443, 52.558842453854432],
            [-1.893281027549564, 52.561307073881288],
            [-1.891639341267259, 52.562439240014442],
            [-1.888505637801243, 52.56381084939003],
            [-1.882752859835051, 52.567441730411076],
            [-1.879779277777185, 52.568835734285415],
            [-1.878525983357617, 52.569620213849745],
            [-1.875808193356318, 52.580638010360758],
            [-1.872862795527939, 52.584106750574001],
            [-1.872571162132064, 52.584929039006347],
            [-1.870952714646865, 52.586741452000908],
            [-1.867811520103412, 52.588315702767794],
            [-1.867990850548701, 52.588536987591063],
            [-1.863787673233927, 52.591209442130783],
            [-1.853960975670654, 52.601909076881157],
            [-1.848557984167111, 52.604637020861389],
            [-1.84447761209657, 52.605207913086048],
            [-1.838664105689791, 52.60685613292614],
            [-1.838041323311239, 52.606730271790255],
            [-1.836840060150929, 52.607338138005588],
            [-1.832377305320315, 52.607790444097105],
            [-1.827868453076975, 52.608673092027317]
          ]
        ]
      }
    },
    {
      type: "Feature",
      properties: {
        objectid: 283,
        lad16cd: "E08000027",
        lad16nm: "Dudley",
        lad16nmw: null,
        bng_e: 393191,
        bng_n: 288584,
        long: -2.10171008,
        lat: 52.49512863,
        st_areasha: 97939612.00080578,
        st_lengths: 72680.631095200981
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-2.121533232733216, 52.55680008932093],
            [-2.117961852642253, 52.552784330014489],
            [-2.118481875858106, 52.552578899421867],
            [-2.11783242536388, 52.55181715827505],
            [-2.117237246177512, 52.552063193203466],
            [-2.114662244154867, 52.548710678101827],
            [-2.115512636545345, 52.548475281699083],
            [-2.114528789418715, 52.547285963541732],
            [-2.112206452479086, 52.547939950079474],
            [-2.111474244125892, 52.547077594455082],
            [-2.111990684646447, 52.546054083159618],
            [-2.109644208642234, 52.546476080701055],
            [-2.108250284773684, 52.543929649455045],
            [-2.107765624435303, 52.54410633359209],
            [-2.106109973687939, 52.545463475336582],
            [-2.105090375931865, 52.545813183792347],
            [-2.102324641633281, 52.546085321990233],
            [-2.097319608827613, 52.546006869844447],
            [-2.096202877377069, 52.546455441408412],
            [-2.094187643998366, 52.548111176816008],
            [-2.09370252851896, 52.547439134095931],
            [-2.092104980789097, 52.547953744488886],
            [-2.090057075649554, 52.548847132643949],
            [-2.090350481708095, 52.54955888158085],
            [-2.089158667633862, 52.550177393402741],
            [-2.089362647880518, 52.55110499645221],
            [-2.0890226803556, 52.551473821056732],
            [-2.088576876851852, 52.550497868364396],
            [-2.086426892669886, 52.551396661946903],
            [-2.085012411924291, 52.552812646653479],
            [-2.082197862688567, 52.552515273907325],
            [-2.08146449606852, 52.553109122324415],
            [-2.081373876916758, 52.55519306459432],
            [-2.080816033068756, 52.556564365882707],
            [-2.07978435835474, 52.557011915182983],
            [-2.078049601899294, 52.556909631866077],
            [-2.075275995833076, 52.553102448180056],
            [-2.073947495987611, 52.549864273071783],
            [-2.072864227241164, 52.545847361615841],
            [-2.073000629608686, 52.541822499834176],
            [-2.073343319150262, 52.540429795631709],
            [-2.07236304414268, 52.540531957805804],
            [-2.073571999824177, 52.538770149549393],
            [-2.074659051051571, 52.539004034734134],
            [-2.075231858438961, 52.537727114595583],
            [-2.074127211650579, 52.53749504276113],
            [-2.075921493542221, 52.534089421748327],
            [-2.079082060592324, 52.535649788643497],
            [-2.079274814090913, 52.535430279366579],
            [-2.078550121024109, 52.533332498042945],
            [-2.077126442060837, 52.5327185260467],
            [-2.077680865336479, 52.531990908867016],
            [-2.079628460914979, 52.528021443445773],
            [-2.079596134800409, 52.524069561903872],
            [-2.075787621737216, 52.524072070191579],
            [-2.071443430101657, 52.521831815713632],
            [-2.067840027773398, 52.51903178650651],
            [-2.064342040586118, 52.514395834932905],
            [-2.063224861471817, 52.513704685012137],
            [-2.060455399570132, 52.512729394582315],
            [-2.057263205117222, 52.512256277979496],
            [-2.057464419327758, 52.511720354394683],
            [-2.058033133638534, 52.511740836926776],
            [-2.057890584937399, 52.51087965019628],
            [-2.059072388571189, 52.509877604405681],
            [-2.059980771112953, 52.509381763482303],
            [-2.061391065049065, 52.509560873221396],
            [-2.062447873932654, 52.507706589300462],
            [-2.061393529008527, 52.507067962874885],
            [-2.061630324784438, 52.505712996473797],
            [-2.061013817122074, 52.505248581578172],
            [-2.061478695513306, 52.504735882097897],
            [-2.06090959342533, 52.504460176263265],
            [-2.06132328012883, 52.503218448879622],
            [-2.060929054179433, 52.502554307878874],
            [-2.062964207077238, 52.502071426587385],
            [-2.063545943721172, 52.500935651581436],
            [-2.063127651207784, 52.499930820419351],
            [-2.06275045886807, 52.499880692654912],
            [-2.064174311569748, 52.499482595301757],
            [-2.065009466619085, 52.49843834554833],
            [-2.065869132851849, 52.498053119853815],
            [-2.067698818995527, 52.498150943660782],
            [-2.067105055106357, 52.497124657166374],
            [-2.068852351185068, 52.496363138872624],
            [-2.068548624657277, 52.49527997923353],
            [-2.069763824388933, 52.494387450217552],
            [-2.070284133978767, 52.491842997265643],
            [-2.069631403527339, 52.490755643861036],
            [-2.066865468307679, 52.489727831155662],
            [-2.06715836846854, 52.489580271785414],
            [-2.066591075516865, 52.489430504739076],
            [-2.064328588700337, 52.487153641522198],
            [-2.066986913021529, 52.485360527322278],
            [-2.068079565857894, 52.486242641577284],
            [-2.068612361228768, 52.48609493970735],
            [-2.068521263217659, 52.485293947630872],
            [-2.069404657981684, 52.485200860353203],
            [-2.06936157303901, 52.484904212809248],
            [-2.069148644279784, 52.484384687198876],
            [-2.068029516268509, 52.484344895336037],
            [-2.06901792428694, 52.482711763023048],
            [-2.070538699372214, 52.481584474276389],
            [-2.071606099141832, 52.480617326632597],
            [-2.071465386732446, 52.480090661551102],
            [-2.072907731717807, 52.478832083758512],
            [-2.073288082658167, 52.477382630883362],
            [-2.075525745703334, 52.477176305889166],
            [-2.076892547192306, 52.477472904846586],
            [-2.077279162381589, 52.477941974030671],
            [-2.078159463932143, 52.477909038928651],
            [-2.079139210822183, 52.477417494785264],
            [-2.07896055013932, 52.477164978580461],
            [-2.079938308921652, 52.476394819266211],
            [-2.081035674036705, 52.475861837327621],
            [-2.081809754784163, 52.47571930185692],
            [-2.081985445452674, 52.475936764909022],
            [-2.084044758091661, 52.475012040340047],
            [-2.083583412447005, 52.47471749094823],
            [-2.086488406005541, 52.474085200567245],
            [-2.089670920129016, 52.474643727203365],
            [-2.091334155935672, 52.474409678410844],
            [-2.092508998907622, 52.47375070528404],
            [-2.094256211107071, 52.473586560676758],
            [-2.095468763373935, 52.471988075776068],
            [-2.095345009846585, 52.470612743936321],
            [-2.096511967525896, 52.470416678470961],
            [-2.097041358830798, 52.469460613324564],
            [-2.097080122374769, 52.468380924619744],
            [-2.093641324312761, 52.468302726965589],
            [-2.090906651427248, 52.467779912405774],
            [-2.089181818684859, 52.467920533305254],
            [-2.085783616715041, 52.46672647039474],
            [-2.084639522125298, 52.465785146978256],
            [-2.083428103445695, 52.465794099387878],
            [-2.081772782143465, 52.463735703092311],
            [-2.080193647936186, 52.463045476633056],
            [-2.079229543548731, 52.463009189466327],
            [-2.077942091304497, 52.464034972439457],
            [-2.076646648936919, 52.463990884414599],
            [-2.076124771982362, 52.464317555384007],
            [-2.07434520781946, 52.463401705501283],
            [-2.073967966220156, 52.461413298434046],
            [-2.072215396750681, 52.460727566259436],
            [-2.066369344171221, 52.461540141283045],
            [-2.064505935052539, 52.461489048677642],
            [-2.063310471834526, 52.462218756361594],
            [-2.061890473359961, 52.462436197505049],
            [-2.059022631004521, 52.461960258113479],
            [-2.056792674995565, 52.462898113006901],
            [-2.05546020957295, 52.462611060550479],
            [-2.055091645456371, 52.463277380689973],
            [-2.052899962052981, 52.464377007792002],
            [-2.051078508859598, 52.463761095897453],
            [-2.049411056205154, 52.466550510854155],
            [-2.04890317434124, 52.466465252594219],
            [-2.048025506286543, 52.467495930377034],
            [-2.047502905886548, 52.46749973763324],
            [-2.047114100515168, 52.47003685796065],
            [-2.044732907507271, 52.470668882826466],
            [-2.042436823671199, 52.472524373918908],
            [-2.04175466612212, 52.473544957180934],
            [-2.041037437662019, 52.473182927488509],
            [-2.03746780156764, 52.473721656068619],
            [-2.034599411090163, 52.474836433463693],
            [-2.03129857419533, 52.47692396321635],
            [-2.030038173315842, 52.476774113612564],
            [-2.023467405220952, 52.479615539065556],
            [-2.022908237916896, 52.480308756788453],
            [-2.022755267650352, 52.480536256842896],
            [-2.022167450738711, 52.479846857969434],
            [-2.020982252870803, 52.47715005179024],
            [-2.018470796311986, 52.474408602615682],
            [-2.015578496453611, 52.471921493827224],
            [-2.014379562435724, 52.470233275007033],
            [-2.013020692331653, 52.464709147541527],
            [-2.012890540350318, 52.462489541581519],
            [-2.013249528511593, 52.46217575064383],
            [-2.013249515302932, 52.462132611302387],
            [-2.01308997936355, 52.460268998893973],
            [-2.011763067455, 52.457207128037254],
            [-2.011510917025078, 52.455349812519771],
            [-2.012126642614227, 52.452178087314152],
            [-2.013044278192247, 52.450358393276382],
            [-2.013517929243688, 52.449643658008213],
            [-2.013239349968182, 52.448341051851969],
            [-2.015274025514464, 52.447644006410606],
            [-2.016518457273633, 52.446716962053628],
            [-2.017440957738935, 52.443241295403631],
            [-2.017007512645688, 52.440659446633212],
            [-2.016996991776906, 52.432668255179379],
            [-2.024773042915488, 52.434867622739368],
            [-2.024887292013338, 52.434027002134933],
            [-2.02374546867103, 52.433317050542833],
            [-2.023690746357083, 52.432594200296556],
            [-2.026045155644882, 52.43207952772854],
            [-2.026197038507788, 52.430145752155063],
            [-2.027805380531336, 52.429216707127694],
            [-2.029331937358945, 52.429029305333671],
            [-2.028977361427336, 52.428832568382063],
            [-2.029713091692376, 52.427286989514769],
            [-2.036994491449899, 52.427531175631088],
            [-2.036950768901959, 52.428023883048922],
            [-2.037578767971726, 52.428026379868868],
            [-2.038117694213662, 52.428787623685494],
            [-2.038068121997624, 52.429232699605279],
            [-2.037534259770482, 52.429293985707943],
            [-2.037349302527588, 52.429683291645297],
            [-2.037874696021145, 52.430060686865815],
            [-2.03696609986292, 52.430532998148855],
            [-2.037497383675003, 52.430840290654302],
            [-2.036882678036925, 52.43097529717874],
            [-2.037667155377576, 52.431546830443352],
            [-2.037538408505938, 52.432443190421843],
            [-2.038162136280158, 52.432481635750761],
            [-2.037599327521034, 52.433058093523528],
            [-2.038447109038292, 52.433714083135406],
            [-2.038136941857257, 52.434051303146347],
            [-2.039849359700418, 52.437543349046912],
            [-2.03849533432232, 52.438503929558564],
            [-2.038637039119381, 52.438964220681221],
            [-2.037137309135543, 52.439824173785375],
            [-2.037115982819349, 52.440708725588983],
            [-2.037887521292092, 52.441542783447872],
            [-2.039745385583749, 52.441389383320818],
            [-2.039855140751246, 52.440703334051022],
            [-2.040401475585404, 52.441265042478094],
            [-2.044556782828211, 52.440662999468834],
            [-2.044687042744973, 52.440058814451262],
            [-2.046391910032086, 52.439941317208884],
            [-2.04709697344244, 52.440392296399622],
            [-2.049166010248691, 52.439665084042609],
            [-2.051490185809012, 52.440813943921597],
            [-2.052171019514701, 52.440518766024326],
            [-2.053600917302139, 52.440602605356069],
            [-2.055717269145037, 52.44129922824181],
            [-2.058496979525253, 52.440752252274372],
            [-2.059269773136486, 52.439967891135808],
            [-2.059636695519974, 52.439354581957183],
            [-2.0592358833346, 52.438851307104706],
            [-2.05945724694915, 52.437245587266801],
            [-2.060212149136249, 52.436384026673089],
            [-2.059473585790387, 52.436233322846654],
            [-2.059315015048732, 52.43538202123645],
            [-2.058704128878838, 52.435013751555083],
            [-2.058653561222427, 52.433562841816943],
            [-2.059165631672037, 52.432610544033444],
            [-2.058948525152192, 52.430777570827281],
            [-2.059522404488623, 52.428842640761935],
            [-2.06071924469349, 52.427523119083723],
            [-2.062473557518473, 52.427416149507579],
            [-2.065793816701704, 52.428072403339577],
            [-2.065877230269712, 52.428793330815218],
            [-2.066660222162884, 52.429201999938101],
            [-2.066712551839318, 52.429726029220674],
            [-2.065356052660547, 52.430425385589032],
            [-2.063831280216555, 52.430685061102608],
            [-2.062355663075576, 52.432440743012322],
            [-2.067552258212951, 52.432543929095701],
            [-2.068014681851013, 52.43294917728462],
            [-2.067632103438191, 52.434706894486681],
            [-2.068057909767928, 52.435180467814426],
            [-2.068606894844017, 52.434454592053584],
            [-2.069773113323223, 52.434319994387828],
            [-2.070976723248975, 52.433687277274181],
            [-2.071510918318435, 52.433900945768009],
            [-2.073290520807099, 52.433768545755612],
            [-2.074309447615829, 52.432680155209063],
            [-2.074739008973076, 52.43269156790587],
            [-2.074817605193461, 52.433983374729806],
            [-2.077941655353028, 52.433923831027059],
            [-2.078269570378109, 52.433030889251164],
            [-2.079897820146095, 52.432257504458534],
            [-2.082110473332829, 52.431716645777414],
            [-2.082670468198666, 52.432350948970431],
            [-2.083421556602387, 52.43206363061261],
            [-2.084618977124193, 52.432130182704171],
            [-2.086055969357929, 52.432910422302626],
            [-2.085511159854918, 52.433380953327308],
            [-2.086458948103125, 52.433648177643335],
            [-2.086969872990898, 52.434630401445396],
            [-2.087518363050162, 52.43454731070107],
            [-2.087227151350282, 52.436799513308216],
            [-2.088741489488643, 52.440113044822958],
            [-2.090476456527764, 52.441064665981365],
            [-2.090793787538852, 52.441606454668374],
            [-2.090269208441713, 52.442624595810805],
            [-2.094143704926032, 52.44375155875656],
            [-2.094253182794382, 52.444008601967063],
            [-2.092879753220426, 52.445021946560274],
            [-2.093286283260073, 52.44526797188643],
            [-2.095677757782855, 52.444902874002906],
            [-2.098571086590696, 52.445269066084364],
            [-2.102246126537968, 52.443947120740738],
            [-2.105255368393406, 52.444193516690135],
            [-2.107030622290127, 52.442191583907373],
            [-2.108783243881597, 52.44120828153919],
            [-2.111762541154803, 52.437263421675752],
            [-2.11246647432665, 52.437549451969417],
            [-2.112902959821747, 52.437400741920939],
            [-2.114648888294489, 52.435645965913118],
            [-2.117253417020555, 52.43434525770612],
            [-2.117524329290467, 52.433929677447189],
            [-2.119668142748885, 52.434705118427893],
            [-2.122887206898397, 52.433406357172188],
            [-2.127765406594778, 52.432690987374301],
            [-2.127787929398814, 52.432344855584837],
            [-2.129702590788242, 52.432196181702693],
            [-2.129026608649797, 52.430903266994434],
            [-2.129755586103794, 52.430712831904188],
            [-2.129275133820322, 52.429886243127513],
            [-2.130465632286503, 52.429617915405238],
            [-2.132279888791086, 52.429916166898394],
            [-2.133096532862252, 52.427603941249643],
            [-2.135484838669782, 52.428046193248193],
            [-2.136032249326923, 52.426253911430059],
            [-2.143577281635023, 52.426040869188363],
            [-2.143583219960127, 52.42603996296036],
            [-2.146607842038828, 52.426358985139721],
            [-2.164856424165801, 52.430189820530423],
            [-2.170323550279622, 52.439058800358296],
            [-2.171268323251701, 52.441415562547085],
            [-2.171794375681968, 52.441632384965345],
            [-2.175374728461565, 52.452994982884469],
            [-2.176425649629159, 52.454537908468666],
            [-2.176354798240317, 52.455964679789631],
            [-2.174928870244977, 52.458564077866114],
            [-2.173894096753799, 52.461125045179209],
            [-2.17426519959905, 52.463798975122486],
            [-2.17155917264435, 52.465883254634818],
            [-2.169367452947341, 52.469315205854443],
            [-2.167518363548867, 52.4712012449939],
            [-2.16742541336041, 52.471526810493451],
            [-2.168084920884944, 52.471542950330544],
            [-2.169102467054142, 52.472374000736792],
            [-2.171810501382223, 52.472571411000395],
            [-2.173769018954645, 52.474211893611837],
            [-2.177878153158318, 52.479351694560066],
            [-2.178487961541233, 52.482681502962407],
            [-2.177636331530734, 52.485102012528031],
            [-2.179521496523985, 52.488782373429757],
            [-2.182253738939653, 52.49313563231739],
            [-2.184274784700703, 52.492865482728135],
            [-2.185181426648378, 52.494798687930789],
            [-2.188665016469243, 52.49449290858113],
            [-2.184613972329851, 52.499992208456582],
            [-2.184789205956379, 52.500332646062475],
            [-2.191754099092478, 52.503382555984508],
            [-2.189426375906192, 52.504747446172154],
            [-2.186624425265151, 52.504772574726431],
            [-2.187689146886866, 52.506063629885169],
            [-2.188006075636509, 52.507145474099339],
            [-2.187108870821208, 52.507492102267044],
            [-2.187987649105543, 52.508348371050374],
            [-2.185854631054343, 52.508788710000196],
            [-2.185651699167529, 52.50851572351916],
            [-2.180521127500664, 52.510234414204092],
            [-2.180260917800149, 52.510740979110274],
            [-2.178248842517145, 52.511634047705797],
            [-2.173822265405663, 52.512304087822578],
            [-2.17281047687522, 52.512825130613059],
            [-2.170380992233449, 52.513291685954528],
            [-2.169988242558824, 52.513080959753594],
            [-2.168391125979237, 52.513499449931487],
            [-2.167158730885304, 52.513380768966762],
            [-2.164642289108275, 52.514626712772873],
            [-2.16339295728385, 52.514696750466015],
            [-2.162077909870411, 52.514145660238334],
            [-2.157453633732028, 52.514880156973007],
            [-2.156916856363981, 52.515185631799923],
            [-2.156229586344509, 52.51502737701734],
            [-2.155181226257151, 52.51524634230438],
            [-2.152675292891278, 52.515027529192118],
            [-2.15055315057003, 52.514122261300507],
            [-2.148786796957234, 52.514680097156194],
            [-2.144129676574122, 52.517154512425776],
            [-2.145294199475182, 52.517715872235122],
            [-2.144522292135578, 52.519605597391617],
            [-2.144588483428362, 52.521369279701389],
            [-2.146048837173922, 52.522644943072024],
            [-2.145540706279037, 52.522736431913145],
            [-2.145750947637273, 52.523473313035744],
            [-2.146071748505328, 52.523322828699314],
            [-2.147573453584114, 52.52414168461371],
            [-2.148104027998065, 52.523710437870875],
            [-2.149852752368362, 52.524787881081465],
            [-2.151574364037961, 52.525237927322202],
            [-2.152215611101533, 52.525681166141212],
            [-2.151994833842448, 52.526184021472375],
            [-2.14703066645215, 52.528008977195142],
            [-2.145949538773092, 52.52867825571375],
            [-2.145979979582505, 52.529427040918065],
            [-2.144235034076767, 52.53041716007403],
            [-2.139392338536372, 52.532662340537968],
            [-2.13738206556306, 52.533278708676889],
            [-2.137402646200759, 52.533718343949289],
            [-2.137167639964046, 52.53401349054591],
            [-2.136520386822637, 52.533974696421453],
            [-2.136477645063742, 52.534458352883668],
            [-2.135569643073059, 52.534493549922367],
            [-2.135429108540935, 52.534841609593265],
            [-2.136754724564603, 52.534908475870573],
            [-2.135395947372875, 52.536031926535209],
            [-2.13660824615244, 52.53615725239144],
            [-2.136314527350897, 52.537476478586321],
            [-2.135656845983146, 52.537461957244858],
            [-2.135662178089243, 52.537732468187379],
            [-2.136591104193972, 52.537759349266089],
            [-2.136894185690935, 52.538042097784391],
            [-2.136491156462356, 52.540255058349594],
            [-2.13581885069871, 52.540714275189906],
            [-2.136104844729156, 52.54167675496975],
            [-2.135710124787816, 52.541802133123099],
            [-2.135478972726374, 52.54336394037653],
            [-2.136794507803029, 52.543429919703861],
            [-2.13696742950868, 52.544963401370836],
            [-2.136060624711721, 52.545493890023245],
            [-2.136832993202793, 52.54680729997046],
            [-2.139156535662543, 52.548049685045491],
            [-2.138157629325498, 52.548805160345843],
            [-2.138047497551287, 52.549433680195861],
            [-2.137478608899873, 52.549525114918353],
            [-2.134895673440206, 52.551722516610205],
            [-2.134570965032587, 52.551630318311915],
            [-2.133462955994603, 52.553430378984721],
            [-2.133492814152644, 52.554051545788944],
            [-2.13169824494555, 52.55416059808104],
            [-2.128387631691623, 52.553821736418143],
            [-2.128337307708503, 52.555284380303014],
            [-2.128074761008659, 52.555787233649646],
            [-2.127215900249807, 52.556147742789122],
            [-2.127332893566727, 52.557322613050502],
            [-2.128396008954496, 52.557683738993887],
            [-2.127603823981821, 52.558191659436822],
            [-2.121533232733216, 52.55680008932093]
          ]
        ]
      }
    },
    {
      type: "Feature",
      properties: {
        objectid: 284,
        lad16cd: "E08000028",
        lad16nm: "Sandwell",
        lad16nmw: null,
        bng_e: 399573,
        bng_n: 290764,
        long: -2.00770998,
        lat: 52.51477051,
        st_areasha: 85597168.057728961,
        st_lengths: 57936.429097174871
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-2.016815959744402, 52.569069704077897],
            [-2.016150300632439, 52.568399169166703],
            [-2.0125031409798, 52.568405011546986],
            [-2.011778568944714, 52.567761420605144],
            [-2.010983715894547, 52.5690497304738],
            [-2.005782648640495, 52.566870073616776],
            [-1.999804608790044, 52.565207136188356],
            [-1.994412752831222, 52.563923277130279],
            [-1.992897675611835, 52.564055312060454],
            [-1.989056395435468, 52.563000553204681],
            [-1.986231967175443, 52.561200476070432],
            [-1.983728989788215, 52.560347901787097],
            [-1.980558338400559, 52.558550427124104],
            [-1.979249893334437, 52.558722763409484],
            [-1.975502030786992, 52.555545056953065],
            [-1.975246708475811, 52.555879420258222],
            [-1.974435896818187, 52.557843507457008],
            [-1.974542861369737, 52.559003247250658],
            [-1.967120108910141, 52.5594652676834],
            [-1.966977268093985, 52.561013284216685],
            [-1.967350505549121, 52.561052122286618],
            [-1.966850717591508, 52.562557709662904],
            [-1.964149175474926, 52.563211381100359],
            [-1.959938880952112, 52.561652099350816],
            [-1.955073814620678, 52.561782566945986],
            [-1.954074707454049, 52.56219658842231],
            [-1.951878884478776, 52.561482851777299],
            [-1.952758446397497, 52.557076388422217],
            [-1.951074261385651, 52.556817683609516],
            [-1.949331018839793, 52.556641612868319],
            [-1.949435335420899, 52.556984251990187],
            [-1.94777243189506, 52.557466239768061],
            [-1.944227945677643, 52.5598928108301],
            [-1.942851683301648, 52.559887664528958],
            [-1.942315063204225, 52.560745958239856],
            [-1.940357351082149, 52.560965180713261],
            [-1.940289932495714, 52.560634325433043],
            [-1.937960298301872, 52.559895098820071],
            [-1.936443207063982, 52.560391383422221],
            [-1.93557302436051, 52.560287561627696],
            [-1.933933102817106, 52.560018750999312],
            [-1.93260813497629, 52.559314124543555],
            [-1.934658267852431, 52.557432796693753],
            [-1.932576151303445, 52.556126322424767],
            [-1.933072163858955, 52.553825232145826],
            [-1.929383993686373, 52.553533617845808],
            [-1.92504159597057, 52.552053899813238],
            [-1.923099435429802, 52.551058395537368],
            [-1.918163011762365, 52.547291044402726],
            [-1.918511499184301, 52.547017081660783],
            [-1.919814814680874, 52.546327565522681],
            [-1.921195680121317, 52.546035413949078],
            [-1.933155210198725, 52.545797300918792],
            [-1.929947014511153, 52.543572267873458],
            [-1.929445396586592, 52.542806883430849],
            [-1.930352430101089, 52.533341996210751],
            [-1.929446050601334, 52.531283727499954],
            [-1.932486668117852, 52.532643836044699],
            [-1.932634247585191, 52.532469565583874],
            [-1.933783808299215, 52.532725451380152],
            [-1.937252084805932, 52.531991092363093],
            [-1.941516130923988, 52.533627608218112],
            [-1.945792417546664, 52.533865191379149],
            [-1.947473613597222, 52.533418287445876],
            [-1.947273745333312, 52.532842832490509],
            [-1.947980247716075, 52.532574332650924],
            [-1.949801686079166, 52.530475950175607],
            [-1.951247080124741, 52.529779854098194],
            [-1.957570898768652, 52.529719364410084],
            [-1.958089744215165, 52.531389840132299],
            [-1.960243408390396, 52.531335755255931],
            [-1.960484703401648, 52.530208467611914],
            [-1.962084639912283, 52.527946251685492],
            [-1.960113697315521, 52.524881833159313],
            [-1.959498490665666, 52.522274583989756],
            [-1.958044532384093, 52.519963709999189],
            [-1.958800571774893, 52.518399729756553],
            [-1.959907882082645, 52.5177079032132],
            [-1.960206159105812, 52.517050759622578],
            [-1.962113994958599, 52.515921404628038],
            [-1.962649416361299, 52.513646251103879],
            [-1.962271580499801, 52.512635596366557],
            [-1.959574769504069, 52.509651903634541],
            [-1.961982136406531, 52.509860393625715],
            [-1.962241356560118, 52.508320494805901],
            [-1.961267518596681, 52.508250890703472],
            [-1.961975362709763, 52.50755891314305],
            [-1.961155502217443, 52.506602126047994],
            [-1.963030919351894, 52.504882094338321],
            [-1.957300223760081, 52.503243043332262],
            [-1.955490291116352, 52.502620275979361],
            [-1.955529594564394, 52.501581083240538],
            [-1.952843967232652, 52.501707759528799],
            [-1.950824572523079, 52.501475877661008],
            [-1.94571903066592, 52.499957040460231],
            [-1.943007886715565, 52.499391186363972],
            [-1.942468502018255, 52.499582447120765],
            [-1.942590924237267, 52.499398175894683],
            [-1.938137840063218, 52.49840975897294],
            [-1.941419420437161, 52.497527694285097],
            [-1.944316074351126, 52.495720380023904],
            [-1.94383026798269, 52.494402154987192],
            [-1.945533941469834, 52.493529195812336],
            [-1.945689116723307, 52.493151617454735],
            [-1.942885299862727, 52.491605824728722],
            [-1.943423384531396, 52.491214143050676],
            [-1.943145243412755, 52.491072908723893],
            [-1.943943414903816, 52.48992074741524],
            [-1.94595199012083, 52.490196780486144],
            [-1.947096550827922, 52.487476009088375],
            [-1.948031585741554, 52.487608625730239],
            [-1.948434339870023, 52.486984896875363],
            [-1.94971091271255, 52.487127444191664],
            [-1.950726000166123, 52.485479134818263],
            [-1.949524647291041, 52.485212515091575],
            [-1.950782889663331, 52.483231684752084],
            [-1.951572634640147, 52.482811219678972],
            [-1.952492341734182, 52.483345620712434],
            [-1.956129135333498, 52.482293425775367],
            [-1.958790888054588, 52.482798658440402],
            [-1.96180662966317, 52.482719676400649],
            [-1.964695180971553, 52.481498822337308],
            [-1.967038258215888, 52.478938267545303],
            [-1.968698416899436, 52.477847376632603],
            [-1.968411399316824, 52.477731273850019],
            [-1.969030448791457, 52.476778502816138],
            [-1.96538023732159, 52.475307611247516],
            [-1.967135976944924, 52.474182617326619],
            [-1.965812925579155, 52.473649112422692],
            [-1.965741098320539, 52.473294000647222],
            [-1.968322575262985, 52.472224943862763],
            [-1.977247769556674, 52.467416381048949],
            [-1.98172010369364, 52.466276375080859],
            [-1.98796291629486, 52.465351188675498],
            [-1.997729164908442, 52.463097985174429],
            [-2.002093212063011, 52.463382969276545],
            [-2.004398030452347, 52.462577358786319],
            [-2.007911199330795, 52.461899337679206],
            [-2.013249528511593, 52.46217575064383],
            [-2.012890540350318, 52.462489541581519],
            [-2.013020692331653, 52.464709147541527],
            [-2.014379562435724, 52.470233275007033],
            [-2.015578496453611, 52.471921493827224],
            [-2.018470796311986, 52.474408602615682],
            [-2.020982252870803, 52.47715005179024],
            [-2.022167450738711, 52.479846857969434],
            [-2.022755267650352, 52.480536256842896],
            [-2.022908237916896, 52.480308756788453],
            [-2.023467405220952, 52.479615539065556],
            [-2.030038173315842, 52.476774113612564],
            [-2.03129857419533, 52.47692396321635],
            [-2.034599411090163, 52.474836433463693],
            [-2.03746780156764, 52.473721656068619],
            [-2.041037437662019, 52.473182927488509],
            [-2.04175466612212, 52.473544957180934],
            [-2.042436823671199, 52.472524373918908],
            [-2.044732907507271, 52.470668882826466],
            [-2.047114100515168, 52.47003685796065],
            [-2.047502905886548, 52.46749973763324],
            [-2.048025506286543, 52.467495930377034],
            [-2.04890317434124, 52.466465252594219],
            [-2.049411056205154, 52.466550510854155],
            [-2.051078508859598, 52.463761095897453],
            [-2.052899962052981, 52.464377007792002],
            [-2.055091645456371, 52.463277380689973],
            [-2.05546020957295, 52.462611060550479],
            [-2.056792674995565, 52.462898113006901],
            [-2.059022631004521, 52.461960258113479],
            [-2.061890473359961, 52.462436197505049],
            [-2.063310471834526, 52.462218756361594],
            [-2.064505935052539, 52.461489048677642],
            [-2.066369344171221, 52.461540141283045],
            [-2.072215396750681, 52.460727566259436],
            [-2.073967966220156, 52.461413298434046],
            [-2.07434520781946, 52.463401705501283],
            [-2.076124771982362, 52.464317555384007],
            [-2.076646648936919, 52.463990884414599],
            [-2.077942091304497, 52.464034972439457],
            [-2.079229543548731, 52.463009189466327],
            [-2.080193647936186, 52.463045476633056],
            [-2.081772782143465, 52.463735703092311],
            [-2.083428103445695, 52.465794099387878],
            [-2.084639522125298, 52.465785146978256],
            [-2.085783616715041, 52.46672647039474],
            [-2.089181818684859, 52.467920533305254],
            [-2.090906651427248, 52.467779912405774],
            [-2.093641324312761, 52.468302726965589],
            [-2.097080122374769, 52.468380924619744],
            [-2.097041358830798, 52.469460613324564],
            [-2.096511967525896, 52.470416678470961],
            [-2.095345009846585, 52.470612743936321],
            [-2.095468763373935, 52.471988075776068],
            [-2.094256211107071, 52.473586560676758],
            [-2.092508998907622, 52.47375070528404],
            [-2.091334155935672, 52.474409678410844],
            [-2.089670920129016, 52.474643727203365],
            [-2.086488406005541, 52.474085200567245],
            [-2.083583412447005, 52.47471749094823],
            [-2.084044758091661, 52.475012040340047],
            [-2.081985445452674, 52.475936764909022],
            [-2.081809754784163, 52.47571930185692],
            [-2.081035674036705, 52.475861837327621],
            [-2.079938308921652, 52.476394819266211],
            [-2.07896055013932, 52.477164978580461],
            [-2.079139210822183, 52.477417494785264],
            [-2.078159463932143, 52.477909038928651],
            [-2.077279162381589, 52.477941974030671],
            [-2.076892547192306, 52.477472904846586],
            [-2.075525745703334, 52.477176305889166],
            [-2.073288082658167, 52.477382630883362],
            [-2.072907731717807, 52.478832083758512],
            [-2.071465386732446, 52.480090661551102],
            [-2.071606099141832, 52.480617326632597],
            [-2.070538699372214, 52.481584474276389],
            [-2.06901792428694, 52.482711763023048],
            [-2.068029516268509, 52.484344895336037],
            [-2.069148644279784, 52.484384687198876],
            [-2.06936157303901, 52.484904212809248],
            [-2.069404657981684, 52.485200860353203],
            [-2.068521263217659, 52.485293947630872],
            [-2.068612361228768, 52.48609493970735],
            [-2.068079565857894, 52.486242641577284],
            [-2.066986913021529, 52.485360527322278],
            [-2.064328588700337, 52.487153641522198],
            [-2.066591075516865, 52.489430504739076],
            [-2.06715836846854, 52.489580271785414],
            [-2.066865468307679, 52.489727831155662],
            [-2.069631403527339, 52.490755643861036],
            [-2.070284133978767, 52.491842997265643],
            [-2.069763824388933, 52.494387450217552],
            [-2.068548624657277, 52.49527997923353],
            [-2.068852351185068, 52.496363138872624],
            [-2.067105055106357, 52.497124657166374],
            [-2.067698818995527, 52.498150943660782],
            [-2.065869132851849, 52.498053119853815],
            [-2.065009466619085, 52.49843834554833],
            [-2.064174311569748, 52.499482595301757],
            [-2.06275045886807, 52.499880692654912],
            [-2.063127651207784, 52.499930820419351],
            [-2.063545943721172, 52.500935651581436],
            [-2.062964207077238, 52.502071426587385],
            [-2.060929054179433, 52.502554307878874],
            [-2.06132328012883, 52.503218448879622],
            [-2.06090959342533, 52.504460176263265],
            [-2.061478695513306, 52.504735882097897],
            [-2.061013817122074, 52.505248581578172],
            [-2.061630324784438, 52.505712996473797],
            [-2.061393529008527, 52.507067962874885],
            [-2.062447873932654, 52.507706589300462],
            [-2.061391065049065, 52.509560873221396],
            [-2.059980771112953, 52.509381763482303],
            [-2.059072388571189, 52.509877604405681],
            [-2.057890584937399, 52.51087965019628],
            [-2.058033133638534, 52.511740836926776],
            [-2.057464419327758, 52.511720354394683],
            [-2.057263205117222, 52.512256277979496],
            [-2.060455399570132, 52.512729394582315],
            [-2.063224861471817, 52.513704685012137],
            [-2.064342040586118, 52.514395834932905],
            [-2.067840027773398, 52.51903178650651],
            [-2.071443430101657, 52.521831815713632],
            [-2.075787621737216, 52.524072070191579],
            [-2.079596134800409, 52.524069561903872],
            [-2.079628460914979, 52.528021443445773],
            [-2.077680865336479, 52.531990908867016],
            [-2.077126442060837, 52.5327185260467],
            [-2.078550121024109, 52.533332498042945],
            [-2.079274814090913, 52.535430279366579],
            [-2.079082060592324, 52.535649788643497],
            [-2.075921493542221, 52.534089421748327],
            [-2.074127211650579, 52.53749504276113],
            [-2.075231858438961, 52.537727114595583],
            [-2.074659051051571, 52.539004034734134],
            [-2.073571999824177, 52.538770149549393],
            [-2.07236304414268, 52.540531957805804],
            [-2.073343319150262, 52.540429795631709],
            [-2.073000629608686, 52.541822499834176],
            [-2.072864227241164, 52.545847361615841],
            [-2.073947495987611, 52.549864273071783],
            [-2.072129786655528, 52.550232169182671],
            [-2.070385036606957, 52.550164920067253],
            [-2.069016563151052, 52.54743188708629],
            [-2.06662152976149, 52.548304402067863],
            [-2.063373664017611, 52.548915709896932],
            [-2.061474387142796, 52.546907518832022],
            [-2.050771115087616, 52.550499530367027],
            [-2.050987581614742, 52.55271363223715],
            [-2.048467387853242, 52.551726724606915],
            [-2.041514430819729, 52.553976830505022],
            [-2.041066323383519, 52.554373415667747],
            [-2.04062515095488, 52.554128127203363],
            [-2.037513392622895, 52.557818614644177],
            [-2.034857332326351, 52.558463100242477],
            [-2.031377587504506, 52.560290832292701],
            [-2.02537362281597, 52.562264628853718],
            [-2.027053778116985, 52.56459087432912],
            [-2.016815959744402, 52.569069704077897]
          ]
        ]
      }
    },
    {
      type: "Feature",
      properties: {
        objectid: 285,
        lad16cd: "E08000029",
        lad16nm: "Solihull",
        lad16nmw: null,
        bng_e: 419434,
        bng_n: 281483,
        long: -1.71557999,
        lat: 52.43099976,
        st_areasha: 178280178.86464873,
        st_lengths: 98745.585248467964
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-1.743249535133282, 52.506942697466158],
            [-1.733220298675564, 52.492133869028734],
            [-1.733087489081856, 52.491946541704813],
            [-1.729995773852373, 52.488849757964637],
            [-1.722534180647879, 52.482665356977705],
            [-1.719036328303551, 52.480462654576954],
            [-1.71480895551971, 52.478641045842046],
            [-1.715280183548133, 52.478402126354872],
            [-1.712690960182929, 52.476490899253648],
            [-1.71166448718335, 52.474945714311566],
            [-1.711262943654345, 52.474889013232186],
            [-1.711419888690883, 52.47385018017463],
            [-1.710719276891767, 52.473828698125423],
            [-1.710824778985897, 52.471656965036445],
            [-1.709865490806019, 52.466415215339019],
            [-1.709067274523103, 52.466268559004178],
            [-1.708484297987005, 52.46559828017827],
            [-1.708524312100866, 52.464444931568039],
            [-1.706612913871298, 52.462581068965029],
            [-1.704135555670215, 52.460649254569887],
            [-1.70041496855963, 52.458688184283396],
            [-1.697455704095972, 52.454765455513979],
            [-1.690030399884703, 52.448645647471231],
            [-1.686486251472116, 52.446308739476436],
            [-1.685353671115855, 52.445036343752086],
            [-1.684704623626219, 52.442800600698234],
            [-1.684216766794679, 52.442510712459573],
            [-1.684425370823561, 52.441512490312192],
            [-1.683557202178443, 52.440520381327559],
            [-1.682040497983038, 52.439701781183487],
            [-1.678152478828817, 52.438691596180199],
            [-1.676603403685019, 52.437893598594869],
            [-1.677161978105399, 52.436341636572784],
            [-1.670751220133468, 52.436772542856559],
            [-1.66659386877219, 52.435456460482285],
            [-1.66455146317726, 52.440020378478806],
            [-1.664896299709014, 52.442659900799981],
            [-1.662294641480418, 52.444284184390348],
            [-1.658327065724333, 52.441959689500472],
            [-1.654876350275915, 52.440739603783847],
            [-1.654683440028371, 52.440963817790475],
            [-1.652801284892287, 52.440658938221901],
            [-1.651144202470691, 52.440931869418883],
            [-1.650710560361201, 52.441256027091711],
            [-1.648228876853681, 52.441604672205081],
            [-1.647004098286858, 52.442081946357582],
            [-1.645259240584489, 52.442081222934696],
            [-1.643265442191735, 52.443047047853199],
            [-1.641405086747152, 52.443328217202662],
            [-1.638309232136703, 52.445360483552918],
            [-1.637400904397825, 52.447576444629178],
            [-1.634965616982008, 52.448670194985709],
            [-1.63460746962525, 52.450169550180185],
            [-1.633652318704153, 52.450725798722978],
            [-1.633163072885812, 52.452050295005428],
            [-1.629723156460552, 52.453757630048059],
            [-1.626927524607672, 52.456166212961456],
            [-1.624670262677846, 52.457014054596826],
            [-1.625951862006548, 52.459289873781771],
            [-1.625792571235981, 52.460546177600804],
            [-1.626659060847529, 52.461285255908216],
            [-1.626888145790006, 52.462221842570152],
            [-1.624460338992658, 52.463523100081417],
            [-1.621736823770514, 52.463413769240667],
            [-1.618326298984356, 52.464121998868386],
            [-1.616610120006928, 52.463443112201837],
            [-1.614220864795508, 52.46298399987284],
            [-1.612209388583298, 52.461078735122399],
            [-1.610722728216531, 52.458587202775476],
            [-1.606023916204088, 52.458225549121529],
            [-1.60383600318704, 52.456682736779975],
            [-1.602356197865792, 52.456450392158807],
            [-1.600168112234566, 52.454803165793805],
            [-1.598555299109009, 52.454315887572797],
            [-1.596703706816939, 52.455640100376982],
            [-1.595496071894444, 52.455903895671732],
            [-1.593549267478811, 52.453487862341511],
            [-1.594804197619266, 52.45303551156411],
            [-1.593658878469351, 52.45180713030279],
            [-1.595911171193361, 52.451379666613001],
            [-1.595314081005888, 52.450061498906038],
            [-1.594225987748613, 52.448698505790496],
            [-1.593681332945356, 52.448560925941379],
            [-1.59285474580836, 52.445342270299193],
            [-1.59523782853306, 52.439910580344353],
            [-1.595871205446149, 52.439672689156524],
            [-1.596691567806951, 52.438428561239455],
            [-1.598991520515041, 52.439487375249072],
            [-1.604410565526877, 52.440026078922713],
            [-1.6057019953037, 52.440035781696295],
            [-1.607337870863254, 52.439037945392336],
            [-1.608279867209342, 52.43882527737923],
            [-1.609573167696411, 52.437960279969843],
            [-1.609585713252707, 52.436539846116588],
            [-1.608951834503095, 52.435696253203211],
            [-1.609744386716623, 52.434887117342008],
            [-1.609754176841302, 52.433613260538067],
            [-1.606245106859256, 52.432904925363566],
            [-1.606554947122812, 52.430984695513402],
            [-1.608121942198513, 52.431082555753662],
            [-1.611405854388944, 52.432118230954984],
            [-1.614458898531434, 52.427952347731186],
            [-1.613296303912759, 52.427199624968445],
            [-1.610592788330433, 52.426246799777125],
            [-1.60725094036457, 52.425819543806789],
            [-1.606462178533981, 52.425371052328984],
            [-1.609391128016393, 52.42409509128521],
            [-1.611063349264043, 52.42273413605524],
            [-1.611103802972072, 52.422325247399897],
            [-1.604714870991391, 52.418663947796311],
            [-1.603248260574022, 52.416763927190672],
            [-1.602184315916479, 52.416041172119854],
            [-1.60220843997237, 52.415811981121507],
            [-1.604618973050128, 52.415897353094572],
            [-1.603695516599855, 52.409180479415653],
            [-1.604062122904043, 52.409117894943819],
            [-1.603404042941934, 52.407743741593706],
            [-1.60588529335475, 52.407270210875588],
            [-1.605807706993212, 52.405911573395748],
            [-1.603684774180381, 52.404466023054482],
            [-1.601340342541153, 52.404632595358372],
            [-1.601233893629287, 52.403722425653299],
            [-1.604317091524387, 52.403457668823222],
            [-1.604408579205078, 52.401777660906411],
            [-1.604283346105556, 52.399993660763073],
            [-1.601597992698212, 52.395922897161128],
            [-1.602701446125779, 52.39579350190742],
            [-1.60226084951722, 52.394932630306712],
            [-1.600780036011382, 52.395041784765588],
            [-1.600026870228961, 52.392853732802614],
            [-1.601049605494636, 52.3928535912057],
            [-1.601610241119062, 52.391464742556664],
            [-1.603152925238083, 52.390346121521077],
            [-1.602516250844848, 52.389738940509432],
            [-1.601077406776176, 52.389283729076034],
            [-1.603294352373244, 52.38817816329361],
            [-1.6020038095831, 52.387402513502991],
            [-1.60343309108236, 52.385970649206634],
            [-1.603780556141286, 52.386049106446215],
            [-1.604151846560133, 52.385603576516708],
            [-1.605042630158664, 52.385723392890412],
            [-1.605466061663926, 52.384876198061676],
            [-1.604592835002299, 52.384759050675548],
            [-1.605179562671138, 52.383884451180826],
            [-1.607519449914824, 52.384610615554465],
            [-1.608816469965129, 52.382981418180286],
            [-1.609056620468158, 52.383413706499098],
            [-1.609785348292593, 52.383403530088721],
            [-1.609404296997278, 52.382972576107157],
            [-1.61029294559331, 52.382490896222919],
            [-1.606925635428472, 52.380991859192569],
            [-1.608030447427637, 52.376339502203557],
            [-1.608917958650806, 52.37648093896788],
            [-1.608907715125181, 52.375816542338477],
            [-1.611701524019057, 52.37465250557851],
            [-1.615381564327245, 52.374439750110021],
            [-1.616370468273496, 52.374576966457489],
            [-1.618155499841337, 52.37624050446265],
            [-1.618247675297711, 52.373386431323432],
            [-1.617495282423438, 52.373421748462505],
            [-1.617051428776215, 52.372607563792918],
            [-1.617688063142037, 52.371852687575661],
            [-1.618540954217859, 52.371563254392001],
            [-1.619025668997166, 52.370542656266281],
            [-1.622243893597367, 52.37172711956056],
            [-1.623685944584896, 52.371763172109304],
            [-1.624847508805892, 52.370241217026361],
            [-1.626626346771992, 52.36917875907551],
            [-1.620976964970949, 52.367868013238727],
            [-1.623411402343336, 52.365535686177942],
            [-1.626505282592732, 52.366631469385446],
            [-1.629777067341894, 52.365090944631625],
            [-1.631582944702095, 52.365689046469889],
            [-1.63345870435998, 52.36422683918267],
            [-1.636469008075316, 52.365153135739995],
            [-1.638096803659876, 52.363992974407161],
            [-1.641763977723252, 52.362519834646363],
            [-1.644075036474411, 52.362201371054994],
            [-1.644853385652957, 52.36183153437171],
            [-1.644998200587524, 52.360984167909663],
            [-1.646478280794108, 52.359519575440345],
            [-1.64842848013241, 52.356727724277064],
            [-1.651320681965255, 52.356405452015494],
            [-1.653096272993582, 52.359922223932713],
            [-1.660898153052758, 52.365654495256116],
            [-1.664059694425834, 52.363953536474476],
            [-1.666073893811519, 52.364438458581354],
            [-1.666822111056123, 52.364933268673795],
            [-1.668114960778081, 52.36447835598333],
            [-1.669994488089305, 52.364894438673396],
            [-1.672542462588379, 52.363112537704758],
            [-1.675064904902066, 52.363778464743113],
            [-1.677949656641368, 52.364118087068583],
            [-1.679630557535748, 52.363579621068268],
            [-1.680613590324457, 52.363701814613876],
            [-1.684056244880246, 52.363238222140616],
            [-1.684566755766336, 52.363114657213934],
            [-1.684716397299463, 52.362520795941265],
            [-1.683700673112832, 52.360381101884663],
            [-1.685694176295246, 52.358208090712466],
            [-1.686186948828915, 52.358084471611122],
            [-1.685872290813362, 52.356888823531989],
            [-1.685414423284518, 52.356855251867898],
            [-1.684940393887584, 52.355995403554665],
            [-1.68755333382493, 52.354421863445708],
            [-1.691372549847361, 52.353102264175917],
            [-1.692635777828113, 52.351543056655515],
            [-1.693894820440788, 52.350997897954926],
            [-1.696241267238595, 52.35436540353863],
            [-1.698101186012736, 52.355716869322016],
            [-1.700026727163815, 52.354740051480064],
            [-1.704098883187395, 52.354194694913069],
            [-1.707224482691991, 52.355141947390166],
            [-1.710279331126559, 52.355005667731795],
            [-1.711382516486389, 52.355362565970353],
            [-1.712643977168584, 52.356237614190249],
            [-1.712845985887933, 52.356786528827627],
            [-1.715102746978042, 52.357933770158766],
            [-1.717149942454939, 52.358130118839085],
            [-1.718346124396484, 52.358676902653954],
            [-1.718765853808398, 52.357324009265291],
            [-1.718555680811155, 52.355722368363388],
            [-1.720218437785922, 52.357259148286758],
            [-1.720834144465016, 52.359052280244541],
            [-1.720097449024339, 52.36315454518882],
            [-1.718032232079333, 52.366000503754051],
            [-1.717738733543297, 52.367822935158252],
            [-1.718242351069173, 52.369463112096696],
            [-1.720267194409157, 52.372558654939517],
            [-1.720805089893582, 52.372510494098663],
            [-1.720871806875397, 52.37195503959294],
            [-1.723291108061565, 52.370754320079065],
            [-1.725647828699348, 52.370624006171404],
            [-1.726057101293802, 52.370240196740802],
            [-1.727578157299377, 52.369840077214882],
            [-1.728583365503486, 52.370478887597592],
            [-1.728856492358463, 52.369996701390448],
            [-1.729807619251421, 52.370114007951393],
            [-1.730548630041154, 52.370711664006407],
            [-1.73403992310795, 52.370702487932888],
            [-1.735242380156211, 52.370047114000421],
            [-1.735758954137442, 52.368875120654742],
            [-1.736554850386394, 52.368418349251925],
            [-1.738331771009096, 52.364956590565306],
            [-1.737908662058484, 52.362750369702972],
            [-1.738297571367598, 52.362052715774404],
            [-1.739065835828463, 52.361760428164715],
            [-1.739186155842579, 52.361271589075344],
            [-1.74093654165303, 52.360029395632161],
            [-1.741417238190434, 52.357157203481194],
            [-1.74233968766039, 52.356855344869217],
            [-1.743581728845204, 52.355360260490322],
            [-1.748782846996751, 52.354755589306237],
            [-1.751095060868096, 52.35505625874832],
            [-1.752166593663447, 52.355893725675486],
            [-1.753784950927032, 52.3561093024935],
            [-1.759639815397637, 52.358394933774058],
            [-1.759995318921984, 52.359191326278605],
            [-1.759614459974962, 52.362536632238026],
            [-1.762808027021764, 52.364260244934826],
            [-1.767068977230441, 52.364696608867135],
            [-1.77017081503052, 52.364088643426108],
            [-1.770082822448001, 52.364642286586239],
            [-1.772033868093625, 52.365348171759763],
            [-1.775748073822348, 52.365900994646097],
            [-1.779232581285092, 52.364524807892792],
            [-1.780177548543206, 52.3638118752392],
            [-1.779236842601527, 52.360142111797806],
            [-1.778723889977332, 52.360232916194754],
            [-1.778928439138787, 52.357792450350594],
            [-1.7782031254623, 52.357769521964734],
            [-1.778234154165778, 52.356551402272764],
            [-1.77656319453034, 52.355119680917007],
            [-1.7735175415004, 52.3566476231439],
            [-1.772876124044939, 52.35601438591172],
            [-1.771868226990048, 52.355861455193285],
            [-1.771941818709746, 52.355252058400346],
            [-1.773160600743382, 52.355520523787121],
            [-1.774788139372191, 52.354517652181173],
            [-1.773147677738828, 52.352603125547098],
            [-1.7717560370451, 52.35169072458573],
            [-1.771894733485547, 52.351271989802704],
            [-1.77469432623628, 52.350440429435459],
            [-1.776222319370267, 52.349618896257454],
            [-1.775760989914873, 52.347948575866596],
            [-1.777688209936969, 52.347724736272795],
            [-1.779415153154029, 52.347902328662485],
            [-1.779487926484026, 52.3483349475487],
            [-1.784530865257009, 52.350097270838766],
            [-1.783754524630726, 52.35093287008204],
            [-1.784902561438186, 52.35305037304375],
            [-1.785779816026657, 52.353831368920609],
            [-1.788016813269463, 52.355170504774556],
            [-1.791823722614625, 52.356802668851167],
            [-1.797806920045217, 52.358449233649011],
            [-1.7996034118656, 52.358617661688307],
            [-1.803308890798881, 52.362426793735402],
            [-1.804207305478594, 52.362808547995627],
            [-1.80549910884498, 52.363277222832679],
            [-1.806967800026687, 52.365925479956992],
            [-1.80791804903668, 52.366608463676833],
            [-1.812811660728953, 52.366581252794511],
            [-1.813249847014892, 52.365756616502644],
            [-1.819214614261066, 52.366296323849156],
            [-1.82429122171775, 52.365639607033216],
            [-1.824539346510769, 52.366400503429396],
            [-1.82690060275236, 52.36611898438548],
            [-1.827382099964806, 52.366542282635777],
            [-1.829573523274545, 52.367252060607967],
            [-1.830317139580678, 52.365988218681267],
            [-1.831494352843625, 52.366149878964293],
            [-1.831380420453179, 52.36675206339762],
            [-1.831842417451916, 52.366902004565098],
            [-1.833080566394559, 52.366131455230651],
            [-1.834988002557783, 52.367389153057935],
            [-1.836686879041497, 52.36667861509568],
            [-1.838113274515077, 52.366592496053812],
            [-1.841553344890873, 52.365196437653545],
            [-1.842944309316259, 52.365148859714303],
            [-1.849662236977957, 52.366701195157376],
            [-1.863175634822145, 52.366559310859429],
            [-1.863351984246155, 52.367017161033708],
            [-1.868110258739141, 52.368037521614127],
            [-1.869937382804914, 52.368017972245525],
            [-1.872041792893047, 52.367584278069707],
            [-1.870531921961061, 52.368610184413285],
            [-1.870065578957555, 52.369397164453289],
            [-1.87028432066995, 52.36992245673909],
            [-1.869061536934643, 52.3701836383092],
            [-1.868280943901968, 52.371401845267073],
            [-1.867698751514644, 52.371580947688187],
            [-1.867617328561641, 52.372284851251003],
            [-1.866786219376903, 52.372715412234726],
            [-1.866568737944204, 52.373230334096171],
            [-1.865264663902025, 52.373622602773118],
            [-1.86501670126809, 52.374475508569269],
            [-1.863480069012291, 52.375960647276102],
            [-1.863025832976486, 52.377507330034938],
            [-1.86189910502641, 52.378463464867359],
            [-1.862056395956898, 52.378906914109834],
            [-1.861337369191242, 52.38004236964867],
            [-1.861807622155463, 52.381429248281357],
            [-1.860948586531855, 52.383160591035555],
            [-1.861331380080798, 52.383856046538412],
            [-1.858803131881499, 52.385603381712045],
            [-1.858745896007764, 52.386039389479798],
            [-1.857188263736321, 52.386557090377252],
            [-1.858245178539542, 52.387337849181151],
            [-1.848773705809603, 52.394289851194038],
            [-1.84648857122933, 52.397247310709275],
            [-1.845605060448234, 52.399412783105475],
            [-1.845481194081625, 52.400391632326063],
            [-1.849690805309011, 52.401615217269601],
            [-1.850652852837122, 52.401808856280468],
            [-1.851710937792095, 52.400539891082943],
            [-1.853444942583834, 52.401530046367121],
            [-1.856992121980003, 52.402746258172925],
            [-1.861773799618791, 52.403587054739639],
            [-1.863459441922245, 52.404612147346214],
            [-1.863799665653002, 52.404404837593326],
            [-1.86478618640586, 52.40480060883425],
            [-1.865030202468341, 52.40434602952876],
            [-1.866287842006908, 52.404541585687326],
            [-1.868653846182228, 52.404195427302028],
            [-1.868753721207189, 52.404723284418374],
            [-1.86920325257077, 52.407795710521981],
            [-1.868793314957193, 52.407724256330795],
            [-1.867120240725546, 52.408772400769401],
            [-1.866258612923861, 52.40980885858928],
            [-1.865643817245784, 52.409937673028836],
            [-1.866651892271066, 52.411031062367158],
            [-1.864770353717485, 52.410981295759939],
            [-1.864137992000348, 52.41007256524172],
            [-1.862765805125379, 52.409322145704429],
            [-1.857817562701825, 52.408404707518116],
            [-1.853949464221311, 52.408544700261977],
            [-1.850842810760379, 52.41043143959002],
            [-1.850259699590532, 52.41027881479954],
            [-1.849440695793769, 52.410774875428395],
            [-1.84872588202177, 52.410003555921747],
            [-1.847824994519294, 52.409951173776456],
            [-1.843615625158655, 52.410509296384333],
            [-1.842371837522379, 52.412600566714431],
            [-1.839066393313986, 52.41433574103096],
            [-1.834650202023819, 52.417418658701287],
            [-1.833735854648356, 52.418138355588539],
            [-1.834416607544507, 52.418549228237971],
            [-1.832898466854786, 52.419499140768345],
            [-1.830731814402956, 52.422781079680824],
            [-1.828005052959522, 52.425554103243933],
            [-1.827036064051032, 52.427774217035719],
            [-1.825269656688436, 52.429290866710865],
            [-1.819246371458267, 52.430885641539945],
            [-1.8173210338712, 52.432352588316974],
            [-1.816115741989157, 52.43780593498127],
            [-1.81448768601807, 52.437729609514285],
            [-1.813404820964133, 52.438484922346028],
            [-1.811910592776223, 52.440474718455505],
            [-1.812804555965244, 52.440580389444634],
            [-1.811843487185802, 52.441394299123502],
            [-1.812421931805164, 52.441997555758839],
            [-1.811577625788279, 52.442329740241085],
            [-1.812276497319232, 52.442997898320428],
            [-1.809579569470849, 52.44476196441822],
            [-1.810016131662038, 52.445216622138041],
            [-1.809269401785423, 52.445379083591149],
            [-1.808281767078459, 52.446517367294931],
            [-1.806684792740813, 52.449666668855031],
            [-1.806072396355851, 52.449745746344426],
            [-1.80626016763705, 52.451552079491826],
            [-1.805129665858275, 52.453316796718845],
            [-1.805971002526636, 52.45407959409598],
            [-1.805394457009461, 52.454682783241637],
            [-1.804918809259767, 52.454414085932953],
            [-1.800323276036327, 52.458282977791491],
            [-1.798749483696197, 52.457454998475654],
            [-1.795689200893302, 52.455036812089602],
            [-1.795298291977692, 52.45524114083274],
            [-1.79483115178809, 52.455085748423613],
            [-1.793994528377389, 52.454285941860327],
            [-1.790912221298883, 52.453239525774244],
            [-1.791313841048837, 52.452951647467216],
            [-1.790508645017531, 52.452685006137294],
            [-1.79028956531279, 52.452958825557523],
            [-1.789426796894489, 52.452757683133655],
            [-1.788986656536718, 52.453081436594424],
            [-1.782709984183144, 52.450845065799896],
            [-1.78246154431638, 52.45108646188573],
            [-1.781645183385318, 52.451034629782939],
            [-1.781460099950297, 52.450655826557657],
            [-1.779136440386376, 52.450414157634704],
            [-1.779112820814826, 52.450139456772675],
            [-1.777957569062974, 52.450173696030781],
            [-1.777484497356956, 52.450616967234446],
            [-1.77438984967803, 52.45066503682591],
            [-1.773342025700011, 52.450992066188348],
            [-1.772484193782199, 52.450702733346979],
            [-1.769021264000956, 52.451087971949704],
            [-1.766667474964298, 52.450724668155843],
            [-1.766681764749831, 52.451074398254626],
            [-1.762773053835223, 52.45118077326233],
            [-1.761398731421792, 52.450908387796794],
            [-1.759607023761831, 52.451896349917583],
            [-1.754984355299141, 52.456269512746076],
            [-1.763385093782597, 52.463831908177418],
            [-1.763754245825923, 52.466104396658558],
            [-1.761723097991975, 52.467164708280997],
            [-1.759956319611992, 52.46697330346673],
            [-1.758736188604863, 52.467203598570165],
            [-1.759330287880282, 52.468939020807134],
            [-1.75669868142848, 52.471524537489813],
            [-1.755810492385743, 52.471887688815066],
            [-1.759169957062795, 52.475394446368405],
            [-1.759163745733584, 52.476533409017371],
            [-1.758607018179623, 52.47656013653279],
            [-1.758718934120181, 52.477649998120533],
            [-1.759103336530675, 52.479507219601189],
            [-1.759664574232776, 52.479461535423098],
            [-1.759862897460196, 52.480362745173103],
            [-1.758879173674495, 52.480385012442753],
            [-1.759813665397305, 52.482918482818462],
            [-1.759053467432709, 52.483239766133394],
            [-1.759481473462808, 52.483879820358915],
            [-1.760419101828237, 52.483953619637489],
            [-1.761102101564132, 52.485087680614164],
            [-1.761568293111184, 52.485208242259247],
            [-1.760868145911991, 52.48640790691902],
            [-1.761485914396342, 52.486814573914074],
            [-1.762071941940845, 52.48655682521094],
            [-1.763101034846583, 52.486612812291867],
            [-1.763662442627803, 52.48709583820127],
            [-1.761120265998172, 52.488260267844986],
            [-1.762332144707923, 52.488563872941299],
            [-1.762366652575942, 52.49009314663261],
            [-1.761602255355819, 52.490363120194694],
            [-1.761015551975588, 52.491565709080234],
            [-1.760846802318064, 52.49361961452999],
            [-1.760344131200295, 52.493693194628115],
            [-1.759907035366991, 52.494704557958798],
            [-1.758970578208474, 52.495197142502079],
            [-1.756966287610437, 52.496739326821455],
            [-1.755844853877702, 52.499480687378231],
            [-1.758739055548076, 52.500093444648329],
            [-1.758898561592632, 52.499753956540722],
            [-1.761499639169453, 52.500094540318351],
            [-1.761549913118859, 52.499781791350784],
            [-1.764190621706263, 52.499869761134946],
            [-1.764181357055089, 52.500784926419229],
            [-1.770278904255116, 52.501282404852354],
            [-1.770363893444069, 52.50166192635151],
            [-1.771406016975086, 52.501828499859307],
            [-1.771544173561617, 52.501606688680255],
            [-1.772030477299839, 52.501846779462099],
            [-1.772463333469079, 52.50161744474449],
            [-1.779402654159249, 52.501152261085075],
            [-1.78217195419139, 52.501172663167779],
            [-1.781986489224737, 52.501442032895447],
            [-1.782548395142229, 52.501608522663012],
            [-1.791503177471508, 52.502953310703163],
            [-1.794534119381032, 52.50281480744745],
            [-1.796946489850525, 52.502636432365954],
            [-1.798250683408366, 52.502867028721262],
            [-1.799301758511232, 52.503685045868686],
            [-1.799365704734478, 52.504848478697689],
            [-1.7983729935024, 52.505765571246172],
            [-1.794314747922936, 52.506568627288139],
            [-1.794032283090398, 52.507747548208606],
            [-1.794832730958293, 52.508289256741961],
            [-1.793927154481494, 52.508824410232059],
            [-1.791659489665242, 52.509155763069764],
            [-1.787169949685341, 52.509496583922143],
            [-1.782524330211374, 52.51038445815459],
            [-1.773610202988577, 52.513232840193822],
            [-1.768491824686077, 52.514228904982609],
            [-1.764408725455953, 52.514477984904971],
            [-1.760501819354678, 52.514311885487672],
            [-1.75353057342051, 52.512951821913958],
            [-1.747252988918277, 52.510189453576196],
            [-1.744501353642681, 52.508303753911143],
            [-1.743249535133282, 52.506942697466158]
          ]
        ]
      }
    },
    {
      type: "Feature",
      properties: {
        objectid: 286,
        lad16cd: "E08000030",
        lad16nm: "Walsall",
        lad16nmw: null,
        bng_e: 402098,
        bng_n: 300804,
        long: -1.97044003,
        lat: 52.60503006,
        st_areasha: 103998001.49870862,
        st_lengths: 58578.785780769489
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-1.953669888605431, 52.662717180939346],
            [-1.950223913752336, 52.659620630577685],
            [-1.949524230395771, 52.65992958314218],
            [-1.945731053794911, 52.657097963177677],
            [-1.945408321634165, 52.656282503941348],
            [-1.940365746678608, 52.656307945993397],
            [-1.940492060099213, 52.656912122605377],
            [-1.938642076641657, 52.657297719325783],
            [-1.936958597967549, 52.65910738406717],
            [-1.936405787877987, 52.659028901275128],
            [-1.936584747605775, 52.660033127483814],
            [-1.935480828002929, 52.659699921210809],
            [-1.933526496363808, 52.661512893541982],
            [-1.930278797965432, 52.659326538034563],
            [-1.928595992313655, 52.658583923152356],
            [-1.925812029259827, 52.656053424443883],
            [-1.923690040902002, 52.655511776245049],
            [-1.919598645604968, 52.656858495871738],
            [-1.912848825027945, 52.658217444914349],
            [-1.908666412175183, 52.653983798299812],
            [-1.91659012653821, 52.652241986767152],
            [-1.915874745613416, 52.651456637150744],
            [-1.918020988250579, 52.649878648081092],
            [-1.915266523915997, 52.647947540181256],
            [-1.912353365337066, 52.646459495310502],
            [-1.909746258573108, 52.644263155596491],
            [-1.909053638995043, 52.644730947407744],
            [-1.905090160256635, 52.643191496733998],
            [-1.90647862674076, 52.642122857753087],
            [-1.905882327091922, 52.641766406907657],
            [-1.907535610230423, 52.640587333718081],
            [-1.907518022770814, 52.639796180974479],
            [-1.908017038020331, 52.640054589314268],
            [-1.91315973114973, 52.637013613741573],
            [-1.912743659460828, 52.636708644679324],
            [-1.913126096871808, 52.636092226343671],
            [-1.913673322024571, 52.635867856841152],
            [-1.914141077121054, 52.636158569966874],
            [-1.915991344896954, 52.635269895195741],
            [-1.909981700721772, 52.631753225667211],
            [-1.908536663554335, 52.630346979813851],
            [-1.904693483660094, 52.627752242661849],
            [-1.89749254321379, 52.624740040487495],
            [-1.894334637476811, 52.622646318564243],
            [-1.886278552213694, 52.61559895164384],
            [-1.8856530781542, 52.614768654951725],
            [-1.885148972032782, 52.612655550109416],
            [-1.8850217170342, 52.610514948591941],
            [-1.886611874873396, 52.608361618612186],
            [-1.88714501591761, 52.606615465062823],
            [-1.892246640867648, 52.600044179483916],
            [-1.892272479703401, 52.59913622535052],
            [-1.890188080159796, 52.598458297946642],
            [-1.890395233122063, 52.598274161979127],
            [-1.890633407277763, 52.598047813934997],
            [-1.887576464367904, 52.596668657169822],
            [-1.884405288823544, 52.594411888751075],
            [-1.878194158420518, 52.587691235636555],
            [-1.875160813587266, 52.585677011693193],
            [-1.873242880791809, 52.58489201195021],
            [-1.872571162132064, 52.584929039006347],
            [-1.872862795527939, 52.584106750574001],
            [-1.875808193356318, 52.580638010360758],
            [-1.878525983357617, 52.569620213849745],
            [-1.879779277777185, 52.568835734285415],
            [-1.882752859835051, 52.567441730411076],
            [-1.888505637801243, 52.56381084939003],
            [-1.891639341267259, 52.562439240014442],
            [-1.893281027549564, 52.561307073881288],
            [-1.896688422921443, 52.558842453854432],
            [-1.89810229654926, 52.556607822930346],
            [-1.89979919692057, 52.554983919469642],
            [-1.901285824850331, 52.554399014320808],
            [-1.90816282683793, 52.553211651959906],
            [-1.911840720902396, 52.551928899930232],
            [-1.916805284382138, 52.548628667367488],
            [-1.918163011762365, 52.547291044402726],
            [-1.923099435429802, 52.551058395537368],
            [-1.92504159597057, 52.552053899813238],
            [-1.929383993686373, 52.553533617845808],
            [-1.933072163858955, 52.553825232145826],
            [-1.932576151303445, 52.556126322424767],
            [-1.934658267852431, 52.557432796693753],
            [-1.93260813497629, 52.559314124543555],
            [-1.933933102817106, 52.560018750999312],
            [-1.93557302436051, 52.560287561627696],
            [-1.936443207063982, 52.560391383422221],
            [-1.937960298301872, 52.559895098820071],
            [-1.940289932495714, 52.560634325433043],
            [-1.940357351082149, 52.560965180713261],
            [-1.942315063204225, 52.560745958239856],
            [-1.942851683301648, 52.559887664528958],
            [-1.944227945677643, 52.5598928108301],
            [-1.94777243189506, 52.557466239768061],
            [-1.949435335420899, 52.556984251990187],
            [-1.949331018839793, 52.556641612868319],
            [-1.951074261385651, 52.556817683609516],
            [-1.952758446397497, 52.557076388422217],
            [-1.951878884478776, 52.561482851777299],
            [-1.954074707454049, 52.56219658842231],
            [-1.955073814620678, 52.561782566945986],
            [-1.959938880952112, 52.561652099350816],
            [-1.964149175474926, 52.563211381100359],
            [-1.966850717591508, 52.562557709662904],
            [-1.967350505549121, 52.561052122286618],
            [-1.966977268093985, 52.561013284216685],
            [-1.967120108910141, 52.5594652676834],
            [-1.974542861369737, 52.559003247250658],
            [-1.974435896818187, 52.557843507457008],
            [-1.975246708475811, 52.555879420258222],
            [-1.975502030786992, 52.555545056953065],
            [-1.979249893334437, 52.558722763409484],
            [-1.980558338400559, 52.558550427124104],
            [-1.983728989788215, 52.560347901787097],
            [-1.986231967175443, 52.561200476070432],
            [-1.989056395435468, 52.563000553204681],
            [-1.992897675611835, 52.564055312060454],
            [-1.994412752831222, 52.563923277130279],
            [-1.999804608790044, 52.565207136188356],
            [-2.005782648640495, 52.566870073616776],
            [-2.010983715894547, 52.5690497304738],
            [-2.011778568944714, 52.567761420605144],
            [-2.0125031409798, 52.568405011546986],
            [-2.016150300632439, 52.568399169166703],
            [-2.016815959744402, 52.569069704077897],
            [-2.027053778116985, 52.56459087432912],
            [-2.02537362281597, 52.562264628853718],
            [-2.031377587504506, 52.560290832292701],
            [-2.034857332326351, 52.558463100242477],
            [-2.037513392622895, 52.557818614644177],
            [-2.04062515095488, 52.554128127203363],
            [-2.041066323383519, 52.554373415667747],
            [-2.041514430819729, 52.553976830505022],
            [-2.048467387853242, 52.551726724606915],
            [-2.050987581614742, 52.55271363223715],
            [-2.061957902360973, 52.558233569191195],
            [-2.060854107269564, 52.558933533788739],
            [-2.060169253817457, 52.558655189528068],
            [-2.058474735120676, 52.560010782953896],
            [-2.056617601710787, 52.56003595503698],
            [-2.056658121185723, 52.560520529090326],
            [-2.056118256654796, 52.560537863582844],
            [-2.05610247356482, 52.560938792588765],
            [-2.055356112139052, 52.56097599306861],
            [-2.056634996196101, 52.562011976257786],
            [-2.057955119065102, 52.564201260300678],
            [-2.057195156707594, 52.565134778513801],
            [-2.053645468919924, 52.566140593578083],
            [-2.053093860453777, 52.568666081720728],
            [-2.050027477882871, 52.572124907781657],
            [-2.050864449807746, 52.572423914796673],
            [-2.05544063651787, 52.572974745928867],
            [-2.055320341781771, 52.573475481287048],
            [-2.057101663373359, 52.573746136805497],
            [-2.056985583500678, 52.57410757007289],
            [-2.058169807110701, 52.574730885694201],
            [-2.057040584769876, 52.575515394194774],
            [-2.057708071812213, 52.575910597705793],
            [-2.057343856993624, 52.576136445795008],
            [-2.056803174421275, 52.575670089568327],
            [-2.055170818784316, 52.57655907363317],
            [-2.056292605756498, 52.576850718366224],
            [-2.056747980186035, 52.577484280752444],
            [-2.063051204944121, 52.580002717080681],
            [-2.065879552766376, 52.581513272640393],
            [-2.066879566337775, 52.582094363701096],
            [-2.068213745528881, 52.582125055109188],
            [-2.068006801139789, 52.582854218822874],
            [-2.068654109889786, 52.583361801877516],
            [-2.077798990165272, 52.586112329777649],
            [-2.075760879296041, 52.587039610068082],
            [-2.07439889919655, 52.588142669447734],
            [-2.07330368003504, 52.590806088154778],
            [-2.072285427209172, 52.590922741175333],
            [-2.073216981673281, 52.590998557645378],
            [-2.073330257991262, 52.591705063194944],
            [-2.071881131937884, 52.591970268016645],
            [-2.070864405748627, 52.59304782085465],
            [-2.070873808012254, 52.594344221430809],
            [-2.068562990936321, 52.593087915741542],
            [-2.066115974865338, 52.594398209892397],
            [-2.065720993718079, 52.5968229102387],
            [-2.066338080112298, 52.59775031466647],
            [-2.064902784300689, 52.597573166621231],
            [-2.065004197060832, 52.597254873476736],
            [-2.064497737434062, 52.597198532032493],
            [-2.064157443426909, 52.597729951550896],
            [-2.062917198660088, 52.597661418070309],
            [-2.062690221286334, 52.597861144384559],
            [-2.06196933986514, 52.597591819366649],
            [-2.061050130287814, 52.597986927580628],
            [-2.060711681780798, 52.59777760987685],
            [-2.05999601390534, 52.598015328764561],
            [-2.057875977101918, 52.59798673015888],
            [-2.057000750940176, 52.598259558494391],
            [-2.054863386236303, 52.600920605008639],
            [-2.054604953574012, 52.600831752306561],
            [-2.052402522391846, 52.604888044907241],
            [-2.051565498972086, 52.606316929383588],
            [-2.051187496966125, 52.606344055373874],
            [-2.051072662090916, 52.609237891154983],
            [-2.048027765306806, 52.616019282308081],
            [-2.052755594640528, 52.617295596922958],
            [-2.050724007291636, 52.620506706466024],
            [-2.048492124704375, 52.620534608013337],
            [-2.047649017992593, 52.620795669823636],
            [-2.047385273220746, 52.621406184231645],
            [-2.031894305665138, 52.617407346774208],
            [-2.031269218776001, 52.616919331902096],
            [-2.030129010829371, 52.61693850297965],
            [-2.032096210513235, 52.618717082671878],
            [-2.03201405701881, 52.619448840706667],
            [-2.035515130413455, 52.621783421673143],
            [-2.030534248093428, 52.623987305595577],
            [-2.030861180747674, 52.624709070011264],
            [-2.029366858111395, 52.625692917702168],
            [-2.02897975348003, 52.625490803263197],
            [-2.026508287039547, 52.625564183679359],
            [-2.026645526898206, 52.625310624061221],
            [-2.025351192186281, 52.625002562112172],
            [-2.024085330854227, 52.62526983677477],
            [-2.02023097958691, 52.628078066340969],
            [-2.019432144414278, 52.629158727012339],
            [-2.018889689982446, 52.628554699768166],
            [-2.01611727249659, 52.630238949383802],
            [-2.014377731419957, 52.633150925094363],
            [-2.012533883996701, 52.63345319599749],
            [-2.010023818239126, 52.634600560559306],
            [-2.009442983567217, 52.634248223258318],
            [-2.007575462995228, 52.634788579074581],
            [-2.003852099749249, 52.637136929268252],
            [-1.995742493284087, 52.638304632931735],
            [-1.99328502534751, 52.638154439519354],
            [-1.990861961521612, 52.636655676289195],
            [-1.988693544440592, 52.639121386776694],
            [-1.986556433397969, 52.640393208340015],
            [-1.984774469669172, 52.639636997816034],
            [-1.982836416760138, 52.641283631046207],
            [-1.981322230479597, 52.639813558660826],
            [-1.978733073173206, 52.640052275986257],
            [-1.976212203653902, 52.639680543369195],
            [-1.975170987321472, 52.64132992189765],
            [-1.973334466919263, 52.640585212056379],
            [-1.971052212115294, 52.641474677454809],
            [-1.969485689214704, 52.641546184921275],
            [-1.967449234852316, 52.641559128528101],
            [-1.967396408382985, 52.640990048293631],
            [-1.96457400601205, 52.640779754449561],
            [-1.963979055241758, 52.641799077149123],
            [-1.963021272476043, 52.643754026304791],
            [-1.960969243364547, 52.642798669290251],
            [-1.960236397227411, 52.644322196329846],
            [-1.959964380209902, 52.649196275832651],
            [-1.960777312225732, 52.649260353857223],
            [-1.960563490271856, 52.653694979648613],
            [-1.955472478157911, 52.653590644813349],
            [-1.955080210122037, 52.654120917398295],
            [-1.956309524298897, 52.656208811886778],
            [-1.955815796987221, 52.656164503158337],
            [-1.956330920982814, 52.657003460548268],
            [-1.959951278067735, 52.662020977535398],
            [-1.954576238608083, 52.662624962115878],
            [-1.953669888605431, 52.662717180939346]
          ]
        ]
      }
    },
    {
      type: "Feature",
      properties: {
        objectid: 287,
        lad16cd: "E08000031",
        lad16nm: "Wolverhampton",
        lad16nmw: null,
        bng_e: 391463,
        bng_n: 300016,
        long: -2.12746,
        lat: 52.59788132,
        st_areasha: 69439134.319046825,
        st_lengths: 54801.208970738757
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-2.113806833503689, 52.637894712346274],
            [-2.111640796604224, 52.635123522755876],
            [-2.110257110790568, 52.635437663866945],
            [-2.109375627363193, 52.634545789573671],
            [-2.106640536356428, 52.634528516776676],
            [-2.105000860480747, 52.635294970814847],
            [-2.101247030861428, 52.635037528855946],
            [-2.10086081054911, 52.633497012025337],
            [-2.099254542149328, 52.632745966883775],
            [-2.09857734443436, 52.631888890251801],
            [-2.098827775134891, 52.628962551376958],
            [-2.098928530227901, 52.628430247845081],
            [-2.097987800678021, 52.627297480890782],
            [-2.098459779213182, 52.626905966705614],
            [-2.098147195884403, 52.626568219829565],
            [-2.097636147342585, 52.626591111254122],
            [-2.097325361534688, 52.625688786278239],
            [-2.097381596518471, 52.623755960226731],
            [-2.094816501341442, 52.620712383393816],
            [-2.093181000631207, 52.619863228559751],
            [-2.088402442957717, 52.619815674032004],
            [-2.086274166059114, 52.616892821239681],
            [-2.084927140383592, 52.613869701098047],
            [-2.083118403772749, 52.612549511717319],
            [-2.081787923587714, 52.612653793249265],
            [-2.081008169480461, 52.611889252008247],
            [-2.0717528779657, 52.612771760196921],
            [-2.069884543174906, 52.612665034726739],
            [-2.067331604769015, 52.612060602990653],
            [-2.067362357928008, 52.613843283761696],
            [-2.068713034480128, 52.618100900059368],
            [-2.06452763603059, 52.619442711005625],
            [-2.064006570581557, 52.620730407235605],
            [-2.059347541523874, 52.621663285075968],
            [-2.052863462216926, 52.622200297844259],
            [-2.052111607860811, 52.62218355659023],
            [-2.051871646205383, 52.621648746717426],
            [-2.050597781142589, 52.621197155937196],
            [-2.050724007291636, 52.620506706466024],
            [-2.052755594640528, 52.617295596922958],
            [-2.048027765306806, 52.616019282308081],
            [-2.051072662090916, 52.609237891154983],
            [-2.051187496966125, 52.606344055373874],
            [-2.051565498972086, 52.606316929383588],
            [-2.052402522391846, 52.604888044907241],
            [-2.054604953574012, 52.600831752306561],
            [-2.054863386236303, 52.600920605008639],
            [-2.057000750940176, 52.598259558494391],
            [-2.057875977101918, 52.59798673015888],
            [-2.05999601390534, 52.598015328764561],
            [-2.060711681780798, 52.59777760987685],
            [-2.061050130287814, 52.597986927580628],
            [-2.06196933986514, 52.597591819366649],
            [-2.062690221286334, 52.597861144384559],
            [-2.062917198660088, 52.597661418070309],
            [-2.064157443426909, 52.597729951550896],
            [-2.064497737434062, 52.597198532032493],
            [-2.065004197060832, 52.597254873476736],
            [-2.064902784300689, 52.597573166621231],
            [-2.066338080112298, 52.59775031466647],
            [-2.065720993718079, 52.5968229102387],
            [-2.066115974865338, 52.594398209892397],
            [-2.068562990936321, 52.593087915741542],
            [-2.070873808012254, 52.594344221430809],
            [-2.070864405748627, 52.59304782085465],
            [-2.071881131937884, 52.591970268016645],
            [-2.073330257991262, 52.591705063194944],
            [-2.073216981673281, 52.590998557645378],
            [-2.072285427209172, 52.590922741175333],
            [-2.07330368003504, 52.590806088154778],
            [-2.07439889919655, 52.588142669447734],
            [-2.075760879296041, 52.587039610068082],
            [-2.077798990165272, 52.586112329777649],
            [-2.068654109889786, 52.583361801877516],
            [-2.068006801139789, 52.582854218822874],
            [-2.068213745528881, 52.582125055109188],
            [-2.066879566337775, 52.582094363701096],
            [-2.065879552766376, 52.581513272640393],
            [-2.063051204944121, 52.580002717080681],
            [-2.056747980186035, 52.577484280752444],
            [-2.056292605756498, 52.576850718366224],
            [-2.055170818784316, 52.57655907363317],
            [-2.056803174421275, 52.575670089568327],
            [-2.057343856993624, 52.576136445795008],
            [-2.057708071812213, 52.575910597705793],
            [-2.057040584769876, 52.575515394194774],
            [-2.058169807110701, 52.574730885694201],
            [-2.056985583500678, 52.57410757007289],
            [-2.057101663373359, 52.573746136805497],
            [-2.055320341781771, 52.573475481287048],
            [-2.05544063651787, 52.572974745928867],
            [-2.050864449807746, 52.572423914796673],
            [-2.050027477882871, 52.572124907781657],
            [-2.053093860453777, 52.568666081720728],
            [-2.053645468919924, 52.566140593578083],
            [-2.057195156707594, 52.565134778513801],
            [-2.057955119065102, 52.564201260300678],
            [-2.056634996196101, 52.562011976257786],
            [-2.055356112139052, 52.56097599306861],
            [-2.05610247356482, 52.560938792588765],
            [-2.056118256654796, 52.560537863582844],
            [-2.056658121185723, 52.560520529090326],
            [-2.056617601710787, 52.56003595503698],
            [-2.058474735120676, 52.560010782953896],
            [-2.060169253817457, 52.558655189528068],
            [-2.060854107269564, 52.558933533788739],
            [-2.061957902360973, 52.558233569191195],
            [-2.050987581614742, 52.55271363223715],
            [-2.050771115087616, 52.550499530367027],
            [-2.061474387142796, 52.546907518832022],
            [-2.063373664017611, 52.548915709896932],
            [-2.06662152976149, 52.548304402067863],
            [-2.069016563151052, 52.54743188708629],
            [-2.070385036606957, 52.550164920067253],
            [-2.072129786655528, 52.550232169182671],
            [-2.073947495987611, 52.549864273071783],
            [-2.075275995833076, 52.553102448180056],
            [-2.078049601899294, 52.556909631866077],
            [-2.07978435835474, 52.557011915182983],
            [-2.080816033068756, 52.556564365882707],
            [-2.081373876916758, 52.55519306459432],
            [-2.08146449606852, 52.553109122324415],
            [-2.082197862688567, 52.552515273907325],
            [-2.085012411924291, 52.552812646653479],
            [-2.086426892669886, 52.551396661946903],
            [-2.088576876851852, 52.550497868364396],
            [-2.0890226803556, 52.551473821056732],
            [-2.089362647880518, 52.55110499645221],
            [-2.089158667633862, 52.550177393402741],
            [-2.090350481708095, 52.54955888158085],
            [-2.090057075649554, 52.548847132643949],
            [-2.092104980789097, 52.547953744488886],
            [-2.09370252851896, 52.547439134095931],
            [-2.094187643998366, 52.548111176816008],
            [-2.096202877377069, 52.546455441408412],
            [-2.097319608827613, 52.546006869844447],
            [-2.102324641633281, 52.546085321990233],
            [-2.105090375931865, 52.545813183792347],
            [-2.106109973687939, 52.545463475336582],
            [-2.107765624435303, 52.54410633359209],
            [-2.108250284773684, 52.543929649455045],
            [-2.109644208642234, 52.546476080701055],
            [-2.111990684646447, 52.546054083159618],
            [-2.111474244125892, 52.547077594455082],
            [-2.112206452479086, 52.547939950079474],
            [-2.114528789418715, 52.547285963541732],
            [-2.115512636545345, 52.548475281699083],
            [-2.114662244154867, 52.548710678101827],
            [-2.117237246177512, 52.552063193203466],
            [-2.11783242536388, 52.55181715827505],
            [-2.118481875858106, 52.552578899421867],
            [-2.117961852642253, 52.552784330014489],
            [-2.121533232733216, 52.55680008932093],
            [-2.127603823981821, 52.558191659436822],
            [-2.128396008954496, 52.557683738993887],
            [-2.127332893566727, 52.557322613050502],
            [-2.127215900249807, 52.556147742789122],
            [-2.128074761008659, 52.555787233649646],
            [-2.128337307708503, 52.555284380303014],
            [-2.128387631691623, 52.553821736418143],
            [-2.13169824494555, 52.55416059808104],
            [-2.133492814152644, 52.554051545788944],
            [-2.134927896450844, 52.554531814121653],
            [-2.13907174956182, 52.558057301827589],
            [-2.14096280518532, 52.558524376237301],
            [-2.141577171941807, 52.557831442639056],
            [-2.142242166625212, 52.557755959201153],
            [-2.143700449809836, 52.555820493214348],
            [-2.145279454252226, 52.554722744078283],
            [-2.146798803597408, 52.555664800079768],
            [-2.147883365942492, 52.554919930737995],
            [-2.148922536149072, 52.55474966526846],
            [-2.153254532223787, 52.554777380192036],
            [-2.153060322572039, 52.55366015360044],
            [-2.155347329320044, 52.553933169181164],
            [-2.157366637996387, 52.553575410460184],
            [-2.157276727586064, 52.55441161706996],
            [-2.157899435825983, 52.554502457297474],
            [-2.157726689314531, 52.554856876435046],
            [-2.160039293807187, 52.555254690203562],
            [-2.161961492212208, 52.554938326283725],
            [-2.162036307312626, 52.55524208435898],
            [-2.163690416442601, 52.555434020371194],
            [-2.164547715152673, 52.55590834654587],
            [-2.16557479995161, 52.555672344712157],
            [-2.165011957240912, 52.553851769477461],
            [-2.167086806726754, 52.553762576638697],
            [-2.169050062449454, 52.55419126517949],
            [-2.170148552851499, 52.556018241564423],
            [-2.173054554094317, 52.554625937873162],
            [-2.175540364080935, 52.554392198297421],
            [-2.176396781574775, 52.556467524901343],
            [-2.175940968923216, 52.559773813998284],
            [-2.174812276803699, 52.560067664578874],
            [-2.175532005357338, 52.564471619484635],
            [-2.17963695506796, 52.563974569180523],
            [-2.18020966070159, 52.565114541663576],
            [-2.179719269827863, 52.565333768119473],
            [-2.179933160114051, 52.565673251528224],
            [-2.180432794684258, 52.565571742820993],
            [-2.180964280133685, 52.566380952751231],
            [-2.176980295960387, 52.566943474659098],
            [-2.179211705957768, 52.571091598812096],
            [-2.178578598353274, 52.571054810160881],
            [-2.180342560287429, 52.57448984756013],
            [-2.180678301015314, 52.57468525749065],
            [-2.182594097364979, 52.574094368512625],
            [-2.183495504372253, 52.576514857896896],
            [-2.182968890024296, 52.576914797692886],
            [-2.183450026130325, 52.576928521398429],
            [-2.18828275857093, 52.574160132678685],
            [-2.188955226416023, 52.576488285955016],
            [-2.189510730616749, 52.576622295654829],
            [-2.189436690704199, 52.577255295982056],
            [-2.196410656135497, 52.577902865251787],
            [-2.196944725461319, 52.578538453767777],
            [-2.197488271543259, 52.578328952970423],
            [-2.198126080288015, 52.579029970566033],
            [-2.201808196563096, 52.578764822007926],
            [-2.20332768270178, 52.581185901043476],
            [-2.202193373784031, 52.581634690754854],
            [-2.20396719447123, 52.583847630178646],
            [-2.200061612193645, 52.583446100267906],
            [-2.199905535129298, 52.583830298430691],
            [-2.201257855695279, 52.58521060229392],
            [-2.206700911534268, 52.585164368169202],
            [-2.206881670985859, 52.586568218424695],
            [-2.204205674166915, 52.586561184474562],
            [-2.202478864231566, 52.586914745746654],
            [-2.200567620181052, 52.588565002202522],
            [-2.199421833740907, 52.588464395505142],
            [-2.199313239324802, 52.588938385363441],
            [-2.198436053198614, 52.588840102157775],
            [-2.198205788524913, 52.589162320570786],
            [-2.197621180465774, 52.589147032609169],
            [-2.197840953674352, 52.588143419973719],
            [-2.193481650177285, 52.588664880560792],
            [-2.189314410909021, 52.588593435326132],
            [-2.188502258306377, 52.59059493041687],
            [-2.188557454029591, 52.592081779684676],
            [-2.188429134438854, 52.594849959783993],
            [-2.189877257916989, 52.599273309465914],
            [-2.190942662289718, 52.602213020168058],
            [-2.1919369810348, 52.603343259763861],
            [-2.193190181266326, 52.602925831535423],
            [-2.193049832916256, 52.603593989834302],
            [-2.194606422311676, 52.605319320213972],
            [-2.196388778858612, 52.60501431449643],
            [-2.196701016923528, 52.606144745982583],
            [-2.196401847308712, 52.606600085381622],
            [-2.195426644758408, 52.606468689442103],
            [-2.195203266811281, 52.607050620450899],
            [-2.194670639313879, 52.606812438373673],
            [-2.194538793630814, 52.60703463983625],
            [-2.193794999706027, 52.606812079019576],
            [-2.19209723773792, 52.606910112782082],
            [-2.191958726291303, 52.607976489125427],
            [-2.188539112168584, 52.608088127357995],
            [-2.188492628211103, 52.608943963204638],
            [-2.187214026325914, 52.608994613915861],
            [-2.186621319581867, 52.606451453096994],
            [-2.184259433025121, 52.606642989045348],
            [-2.183907041243787, 52.606051999339016],
            [-2.180318427015326, 52.604886221906732],
            [-2.17769268735892, 52.60733983776538],
            [-2.173754517111013, 52.609227248722689],
            [-2.172458929987372, 52.610259437217671],
            [-2.17102505348042, 52.610629185440217],
            [-2.170719261686068, 52.609116631866037],
            [-2.169162164061696, 52.609322968340798],
            [-2.16955773942798, 52.610420008743446],
            [-2.168694531058825, 52.610599279112506],
            [-2.168628989188039, 52.611223264264503],
            [-2.167615234600371, 52.611427815526802],
            [-2.170968457649656, 52.61431868962417],
            [-2.169295123816662, 52.615060023419247],
            [-2.165868664391109, 52.61587210727113],
            [-2.166010316246125, 52.616232474323915],
            [-2.165369032878598, 52.616135322230178],
            [-2.165021746973922, 52.616497182098435],
            [-2.169528830777874, 52.618213291756099],
            [-2.168961865486212, 52.618259938139737],
            [-2.168361909135551, 52.618975454037745],
            [-2.168718709455426, 52.619188930604572],
            [-2.168467312975061, 52.619877887045156],
            [-2.167503273805822, 52.620396198411463],
            [-2.164616535661583, 52.619108434179012],
            [-2.161736325418261, 52.619114204636354],
            [-2.162791334755303, 52.621206410586858],
            [-2.160292539380958, 52.621772600543821],
            [-2.156057366899471, 52.623806400017607],
            [-2.151558957066662, 52.624575440590419],
            [-2.152432140456305, 52.627163342922351],
            [-2.153027820035607, 52.627662440187677],
            [-2.152987806032665, 52.629737358760373],
            [-2.14029131338673, 52.62990767982739],
            [-2.137243958788862, 52.629630765961238],
            [-2.135091698015232, 52.63261967769462],
            [-2.133928649306857, 52.633534366182033],
            [-2.131549465182931, 52.635382548817837],
            [-2.13164923525434, 52.637607386602333],
            [-2.128677640937888, 52.637610657445435],
            [-2.125978258461348, 52.63724320366704],
            [-2.118251173196485, 52.637692633355684],
            [-2.116995976697443, 52.637453834969733],
            [-2.11611918240187, 52.637798997637304],
            [-2.113806833503689, 52.637894712346274]
          ]
        ]
      }
    },
    {
      type: "Feature",
      properties: {
        objectid: 282,
        lad16cd: "E08000026",
        lad16nm: "Coventry",
        lad16nmw: null,
        bng_e: 432807,
        bng_n: 279689,
        long: -1.51908004,
        lat: 52.41423035,
        st_areasha: 98624085.801223561,
        st_lengths: 53000.302416518614
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-1.525923504441046, 52.456344184415165],
            [-1.521578238719014, 52.456305129331263],
            [-1.51757768548569, 52.456767204360816],
            [-1.519059698669081, 52.455141465312586],
            [-1.519663671685566, 52.453325296342847],
            [-1.505042137166775, 52.450072594593948],
            [-1.502862042344849, 52.450814183833188],
            [-1.500033596731617, 52.451021653482179],
            [-1.498723725783366, 52.450998046841747],
            [-1.495861095409678, 52.452212144071027],
            [-1.495408451469528, 52.452029566317059],
            [-1.494306407057653, 52.452669446373349],
            [-1.494772509319351, 52.452959128066475],
            [-1.492627768515717, 52.454429657218753],
            [-1.492862417254589, 52.454884711790186],
            [-1.491719015401337, 52.455007428967122],
            [-1.491758554958453, 52.455915607341311],
            [-1.491303428240254, 52.456462968609294],
            [-1.49191696710485, 52.456605809939674],
            [-1.492005940672619, 52.45757351765328],
            [-1.492814363852771, 52.458424776556996],
            [-1.491990013236136, 52.458567826958081],
            [-1.489675580208252, 52.458015743615995],
            [-1.489129205282418, 52.458422407286001],
            [-1.488204405420655, 52.458478628164777],
            [-1.48684483306297, 52.458200419702663],
            [-1.486849979327754, 52.457632251630507],
            [-1.484705738343024, 52.457249863541854],
            [-1.48302432298993, 52.458069561004038],
            [-1.479213974112972, 52.45708912415521],
            [-1.478904512356966, 52.456743450580696],
            [-1.4773055086956, 52.456938707670432],
            [-1.472835587345998, 52.45636237490271],
            [-1.470823069354571, 52.456920685042626],
            [-1.466312678334498, 52.458485379904879],
            [-1.464248477447351, 52.45806784032213],
            [-1.463929197408623, 52.458300160291515],
            [-1.462021785451618, 52.457824064243262],
            [-1.461340616500791, 52.455761295499293],
            [-1.460579498278263, 52.455779398658315],
            [-1.460333293252063, 52.455214578196546],
            [-1.459784387396088, 52.455580742442706],
            [-1.459061283316581, 52.45514046580071],
            [-1.458754318181949, 52.454733634898972],
            [-1.460427855580358, 52.453621970129703],
            [-1.452173298825552, 52.449640136566231],
            [-1.446061032508868, 52.447528639925743],
            [-1.445482154165423, 52.448280253232689],
            [-1.443655503073671, 52.447404111650961],
            [-1.444382072671309, 52.447073998391176],
            [-1.443653149501399, 52.446772097189388],
            [-1.444348135045181, 52.446377123859932],
            [-1.445023067943608, 52.446409051508532],
            [-1.446467065390784, 52.443065168019359],
            [-1.44666292465945, 52.442584172189555],
            [-1.439824938918387, 52.440255947496702],
            [-1.440101654043342, 52.439668392085686],
            [-1.431873702767103, 52.437508376759901],
            [-1.43170221154848, 52.43677219151764],
            [-1.429938472687981, 52.436774491569302],
            [-1.428793915403287, 52.435761195885355],
            [-1.42521603938662, 52.434779232887976],
            [-1.424154204300436, 52.433981994914483],
            [-1.423946264113382, 52.432889622223001],
            [-1.424438298616109, 52.430689431630086],
            [-1.43240708996077, 52.415673904975954],
            [-1.434721536004002, 52.412666952055645],
            [-1.438063473099424, 52.410102714831616],
            [-1.437106711509976, 52.407658211167728],
            [-1.432652964702521, 52.402695094621052],
            [-1.431040969368784, 52.400257279682783],
            [-1.430884920265716, 52.398106060996305],
            [-1.432257112365932, 52.395859727558083],
            [-1.432667607755976, 52.395021084920813],
            [-1.435828763819671, 52.392247434994736],
            [-1.444973832368343, 52.386359856570849],
            [-1.449499284950594, 52.384230626804431],
            [-1.458454946771172, 52.38177988293095],
            [-1.463140838408977, 52.379652573152612],
            [-1.461469644255513, 52.3774315885817],
            [-1.462933721326138, 52.376385434052153],
            [-1.460411726348156, 52.374790779511244],
            [-1.462093716858643, 52.37406576912548],
            [-1.463760233053487, 52.373754186917353],
            [-1.464023451300936, 52.373250094777667],
            [-1.46634218472978, 52.37451921132768],
            [-1.46470554909569, 52.375514296341834],
            [-1.46661853434021, 52.377187001993988],
            [-1.471018117383369, 52.37645602604907],
            [-1.475923330214467, 52.374691572652416],
            [-1.480419881260101, 52.374301488651966],
            [-1.482287886375159, 52.377101959734063],
            [-1.486614489008869, 52.376813354468929],
            [-1.504509082242873, 52.377790513728769],
            [-1.508180158192527, 52.375805550437342],
            [-1.509372204574777, 52.373091833929834],
            [-1.513923064026224, 52.369045249982847],
            [-1.51470315748688, 52.36996456425144],
            [-1.517988014851016, 52.371922563216366],
            [-1.51848027471732, 52.373530297853861],
            [-1.520011292660074, 52.373077074828664],
            [-1.521094248175657, 52.374533415844589],
            [-1.519821618194261, 52.375536936833967],
            [-1.522791317529918, 52.377498013586163],
            [-1.524661649022289, 52.379384496623999],
            [-1.529929873038589, 52.377846651459393],
            [-1.53267236724488, 52.3761997539983],
            [-1.535489846994547, 52.377592610000569],
            [-1.545688123596942, 52.369254324776023],
            [-1.541903940963738, 52.366617226401829],
            [-1.542888186533076, 52.366028570670359],
            [-1.543346210331434, 52.366327920499131],
            [-1.546819365723082, 52.36534068862904],
            [-1.549401503805641, 52.366322387615277],
            [-1.552423680297211, 52.363875927608881],
            [-1.555016753778401, 52.365086819918069],
            [-1.555566631726533, 52.365024177166049],
            [-1.557465977545921, 52.365717236166425],
            [-1.555853795594537, 52.367735834610336],
            [-1.558265094746279, 52.368639314184961],
            [-1.556917797464755, 52.369714945877362],
            [-1.555562371565842, 52.372040979235528],
            [-1.556771533894898, 52.372448342338245],
            [-1.554911309477175, 52.373680208767567],
            [-1.555003917109864, 52.374407835645201],
            [-1.55931230311247, 52.37558283078009],
            [-1.562645841427793, 52.376875399831171],
            [-1.563156335813226, 52.37917424961848],
            [-1.56482849699951, 52.382278440041965],
            [-1.567808744436207, 52.38476167600988],
            [-1.570548482515816, 52.384197168058108],
            [-1.568786231654304, 52.383654017401504],
            [-1.569572528313888, 52.382881970974324],
            [-1.571383830626956, 52.383348803004417],
            [-1.573028485421798, 52.382521331165528],
            [-1.576718145328716, 52.38277195563321],
            [-1.575798930301366, 52.38455953091141],
            [-1.580125817084333, 52.384877940671274],
            [-1.588007312496449, 52.386094174188059],
            [-1.593953422419338, 52.387878548148379],
            [-1.594727313870908, 52.387442518454606],
            [-1.597400218024165, 52.388226555043069],
            [-1.597703328369573, 52.388027163374005],
            [-1.601077406776176, 52.389283729076034],
            [-1.602516250844848, 52.389738940509432],
            [-1.603152925238083, 52.390346121521077],
            [-1.601610241119062, 52.391464742556664],
            [-1.601049605494636, 52.3928535912057],
            [-1.600026870228961, 52.392853732802614],
            [-1.600780036011382, 52.395041784765588],
            [-1.60226084951722, 52.394932630306712],
            [-1.602701446125779, 52.39579350190742],
            [-1.601597992698212, 52.395922897161128],
            [-1.604283346105556, 52.399993660763073],
            [-1.604408579205078, 52.401777660906411],
            [-1.604317091524387, 52.403457668823222],
            [-1.601233893629287, 52.403722425653299],
            [-1.601340342541153, 52.404632595358372],
            [-1.603684774180381, 52.404466023054482],
            [-1.605807706993212, 52.405911573395748],
            [-1.60588529335475, 52.407270210875588],
            [-1.603404042941934, 52.407743741593706],
            [-1.604062122904043, 52.409117894943819],
            [-1.603695516599855, 52.409180479415653],
            [-1.604618973050128, 52.415897353094572],
            [-1.60220843997237, 52.415811981121507],
            [-1.602184315916479, 52.416041172119854],
            [-1.603248260574022, 52.416763927190672],
            [-1.604714870991391, 52.418663947796311],
            [-1.611103802972072, 52.422325247399897],
            [-1.611063349264043, 52.42273413605524],
            [-1.609391128016393, 52.42409509128521],
            [-1.606462178533981, 52.425371052328984],
            [-1.60725094036457, 52.425819543806789],
            [-1.610592788330433, 52.426246799777125],
            [-1.613296303912759, 52.427199624968445],
            [-1.614458898531434, 52.427952347731186],
            [-1.611405854388944, 52.432118230954984],
            [-1.608121942198513, 52.431082555753662],
            [-1.606554947122812, 52.430984695513402],
            [-1.606245106859256, 52.432904925363566],
            [-1.609754176841302, 52.433613260538067],
            [-1.609744386716623, 52.434887117342008],
            [-1.608951834503095, 52.435696253203211],
            [-1.609585713252707, 52.436539846116588],
            [-1.609573167696411, 52.437960279969843],
            [-1.608279867209342, 52.43882527737923],
            [-1.607337870863254, 52.439037945392336],
            [-1.6057019953037, 52.440035781696295],
            [-1.604410565526877, 52.440026078922713],
            [-1.598991520515041, 52.439487375249072],
            [-1.596691567806951, 52.438428561239455],
            [-1.595871205446149, 52.439672689156524],
            [-1.59523782853306, 52.439910580344353],
            [-1.59285474580836, 52.445342270299193],
            [-1.593681332945356, 52.448560925941379],
            [-1.594225987748613, 52.448698505790496],
            [-1.595314081005888, 52.450061498906038],
            [-1.595911171193361, 52.451379666613001],
            [-1.593658878469351, 52.45180713030279],
            [-1.594804197619266, 52.45303551156411],
            [-1.593549267478811, 52.453487862341511],
            [-1.595496071894444, 52.455903895671732],
            [-1.594618270851447, 52.455976387457625],
            [-1.595659183506347, 52.456575997238929],
            [-1.59575148536024, 52.45757419279321],
            [-1.596525220860195, 52.458430013511048],
            [-1.594929859149607, 52.460673860015397],
            [-1.594013262689097, 52.46144481030403],
            [-1.593065826292384, 52.461555698206141],
            [-1.5899941646722, 52.461087456747642],
            [-1.589871858018792, 52.461896174861025],
            [-1.58565373767962, 52.460154541711212],
            [-1.578713003773991, 52.458135091110996],
            [-1.577529966505285, 52.45842215851296],
            [-1.574052876587453, 52.457908105751471],
            [-1.568429901506985, 52.456072624463026],
            [-1.562968296252607, 52.455964416693298],
            [-1.561201047077833, 52.455206344784472],
            [-1.558531841280399, 52.456649246319635],
            [-1.554298775101303, 52.456428376729697],
            [-1.554004633067542, 52.456838985742557],
            [-1.551430341036102, 52.45702797102291],
            [-1.549239595908046, 52.459284225824263],
            [-1.547570563113555, 52.459573636158446],
            [-1.54527016342647, 52.461440148930059],
            [-1.539800022201777, 52.464782214644224],
            [-1.537023782331049, 52.462409656703301],
            [-1.535042790770079, 52.459460375223593],
            [-1.529686191171759, 52.457071185720629],
            [-1.525923504441046, 52.456344184415165]
          ]
        ]
      }
    }
  ]
};
export default bhamPoly2;
